{
  "A11Y": {
    "TRANSLATABLE_FORM_TAB_ARIA_LABEL": "Amathebhu wokukhetha ulimi lwefomu"
  },
  "ACCESS_CONTROL": {
    "WITHOUT_RIGHT_PERMISSIONS": "Awunawo amalungelo anele okungena kuleli khasi."
  },
  "ADD_TO_CALENDAR": {
    "TITLE": "Ikhalenda",
    "URL_WITH_EVENT": "{description} \n Joyina umhlangano wevidiyo: {url}"
  },
  "ANONYMOUS": "Ongaziwa",
  "API_SAUCE": {
    "CANCEL_ERROR": "Isicelo sesiphakeli siphazamisekile.",
    "CLIENT_ERROR": "Owu, kwenzeke iphutha elingalindelekile.",
    "CONNECTION_ERROR": "Iserver ayitholakali.",
    "NETWORK_ERROR": "Iphutha lenethiwekhi, hlola uxhumano lwakho.",
    "SERVER_ERROR": "Owu, kube nephutha engalindelekile.",
    "TIMEOUT_ERROR": "Isiphequluli asiphendulanga ngesikhathi."
  },
  "ARTICLE": {
    "NOT_PUBLISHED": "Akukashicilelwa",
    "PUBLICATION_ALERT": "Kuhlelwe ngo-{date} ngo-{time}."
  },
  "ASSIGNMENT_CARD": {
    "AVATAR_ALT": "Isithombe somphathi",
    "TITLE": "Umphenduli"
  },
  "ASSIGNMENT_MODAL": {
    "CHOOSE_ADMIN": "Khetha umlawuli",
    "TITLE": "Qoka ukuphathwa kwalesi sipho"
  },
  "ATTACHMENTS": {
    "ERROR": {
      "DELETE_FAILED": "Asikho esikwazile ukukususa lokhu okubambisekayo.",
      "TITLE": "Iphutha - "
    }
  },
  "ATTENDANCE": {
    "ATTEND": "Ngiyabamba iqhaza",
    "ATTENDING": "Kubhalisiwe"
  },
  "AUTH": {
    "ACCEPT_SPACE_PRIVACY": "Ngiyavuma <terms>inqubomgomo yobumfihlo</terms> ka-{spaceName}.",
    "ACCEPT_SPACE_TERMS": "Ngiyavuma <privacy>imigomo yokusetshenziswa</privacy> ye-{spaceName}.",
    "ACCEPT_SPACE_TERMS_AND_PRIVACY": "Ngiyavuma <privacy>inqubomgomo yobumfihlo</privacy> kanye <terms>nemigomo yokusebenzisa</terms> ye-{spaceName}.",
    "ACCEPT_TERMS_AND_PRIVACY": "Ngiyavuma kwe {privacy} nemibandela ye {terms} ye Fluicity Engage.",
    "ARIA_AUTHENTICATE_WITH": "Bhalisa nge-{provider}",
    "AUTH_LIST_TITLE": "Izinsiza zokungena ngemvume zenkampani yangaphandle",
    "BACKGROUND_ALT": "Umfanekiso wasemuva",
    "CONTINUE_WITHOUT_SIGNUP": "Qhubeka ngaphandle kwe-akhawunti",
    "DELETE_TOAST": "Isevisi yokungena ngemvume yenkampani yangaphandle isixhunywe ngempumelelo.",
    "DESCRIPTION": "Ukubhaliswa kwakho ku-Fluicity Engage kuzokuvumela ukuthi ubambe iqhaza ezingxoxweni eziku-{spaceName} futhi kuzokunikeza ukufinyelela kwezinye izingxoxo ezihlelwa ku-Fluicity Engage. Ukuthola ulwazi olwengeziwe mayelana nokuphathwa kwedatha yakho yomuntu siqu nokusebenzisa amalungelo akho, sicela ubheke ku-<b>Inqubomgomo Yobumfihlo.</b>",
    "EMAIL_PLACEHOLDER": "exemple@email.com",
    "ENTITY_SUBSCRIPTION_FORM": {
      "CONTENT": "Uma ujoyina <strong>{spaceName}</strong>, uzokwaziswa ngama-consultations akamuva nezindaba. <br></br><br></br>Ubuye futhi ube negalelo ekuqondeni kangcono ukuthi umsebenzi umele yini inani eliphelele labantu ngokwabelana ngemininingwane ethile:",
      "TITLE": "Joyina {spaceName}!"
    },
    "ERRORS": {
      "CANNOT_DELETE_WITHOUT_PASSWORD": "Setha iphasiwedi ukuze ususe le nsizakalo yokuhlonza yomuntu wesithathu.",
      "DELETE_AUTH_FAILED": "Asikho isikhungo sokwenza kube lula ukukhumbula amagama.",
      "INVALID_EMAIL": "Uhlobo lwekheli lakho le-imeyili alulungile.",
      "NO_ASSOCIATED_ACCOUNT": "Awekho ama-akhawunti axhumene.",
      "REQUIRED_CHECKBOX": "Kufanele uhlolise le bhokisi.",
      "REQUIRED_EMAIL": "Kufanele unikeze ikheli le-imeyili.",
      "REQUIRED_FIRST_NAME": "Kumele unikeze igama lokuqala.",
      "REQUIRED_LAST_NAME": "Kufanele unikeze igama.",
      "REQUIRED_PASSWORD": "Kumele ufake iphasiwedi.",
      "SHORT_PASSWORD": "Iphasiwedi kufanele ibe ubuncane obungu-{count} izinhlamvu."
    },
    "FACEBOOK_LOAD_ERROR": "Kubonakala sengathi isandiso esivuliwe kusiphequluli sakho sivimbela ukusebenzisa i-Facebook yokungena ngemvume. Sicela ungavumeli lesi sandiso uma ufuna ukusebenzisa lo msebenzi.",
    "FIRST_NAME_PLACEHOLDER": "Isibonelo: UJean",
    "FORGOT_PASSWORD": "Ukhohlwe iphasiwedi?",
    "HAS_ACCOUNT": "Usuvele unayo i-akhawunti?",
    "HAS_SIGNED_IN": "Usuxhume ku-{spaceName}!",
    "LAST_NAME_PLACEHOLDER": "Isibonelo: Dupont",
    "LOGIN": "Ngena ngemvume",
    "NAME_PREVIEW": "Abanye abasebenzisi bazokubona njenge:",
    "NO_ACCOUNT": "Awukabi naleli-akhawunti?",
    "OAUTH_BUTTONS": {
      "CSAM": "Joyina nge-CSAM"
    },
    "PAGE_TITLE": "Ngena ngemvume",
    "SIGNUP": "Dala i-akhawunti",
    "SIGNUP_EXTRAS": {
      "DESCRIPTION": "Sicela usisize ukuqonda kangcono ukuthi umsebenzi weplathifomu umelela kanjani inani labantu jikelele. Lolu lwazi luzosetshenziswa kuphela ngenhloso yokuhlola ubuqiniso babahlanganyeli kanye nezibalo ezihlobene nokubamba iqhaza.",
      "PAGE_TITLE": "Isinyathelo sokugcina!",
      "WELCOME_TOAST": "Siyakuhalalisela, usungene ku-{spaceName}!"
    },
    "UNLINK": "Phuma Ngemvume",
    "VERIFY_EMAIL": {
      "CONTENT": "Faka ikhodi yokuqinisekisa oyithole ku-{email}.",
      "RESEND": "Awutholanga i-imeyili? {link}",
      "RESEND_LINK": "Buyisela ikhodi",
      "RESEND_SUCCESS": "Ikhodi entsha yokuqinisekisa ithunyelwe kuwe.",
      "TITLE": "Qinisekisa i-akhawunti yakho",
      "VERIFY_ALERT": "Sicela uhlole ikheli lakho le-imeyili ukuze ubambe iqhaza kuzo zonke izinkulumo.",
      "VERIFY_SUCCESS": "I-akhawunti yakho isiqinisekisiwe ngempumelelo."
    }
  },
  "BACK": "Odlule",
  "BUTTONS": {
    "ACCEPT": "Yamukela",
    "ACCESS_CONSULTATION": "Finyelela ekubonisaneni",
    "ACTIONS": "Izenzo",
    "ADD": "Engeza",
    "ADD_ATTACHMENTS": "Engeza amafayela/izithombe",
    "ADD_NEW_IDEA": "Iminikelo",
    "CANCEL": "Khansela",
    "CHANGE_USER": "Shintsha umsebenzisi",
    "CLEAR": "Susa",
    "CLONE": "Phinda kabili",
    "CLOSE": "Vala",
    "COMMENT": "Beka umbono wakho",
    "CONFIRM": "Qinisekisa",
    "CONTINUE": "Qhubeka",
    "DELETE": "Susa",
    "DELETE_VOTERS": "Susa ababavoti",
    "DRAG_DROP_ATTACHMENTS": "Hudula bese uthulula amafayela/izithombe lapha noma uchofoze",
    "EXPORT": "Thumela ngaphandle",
    "EXPORT_PARTICIPANTS": "Thumela ababambiqhaza",
    "EXPORT_PROPOSALS": "Thumela izintambo zokunikela",
    "EXPORT_RESULTS": "Ukuthekelisa imiphumela",
    "EXPORT_VOTERS": "Thumela abavoti",
    "FILTER": "Hlunga",
    "IGNORE": "Manje cha.",
    "IMPORT": "Ngenisa",
    "IMPORT_VIA_EXCEL": "Ngenisa ifayela le-Excel",
    "IMPORT_VIA_FORM": "Gcwalisa ifomu ku-inthanethi",
    "IMPORT_VOTERS": "Ngenisa abavoti",
    "IN_PROGRESS": "Kuqhubeka…",
    "JOIN": "Joyina",
    "LEARN_MORE": "Funda kabanzi",
    "NO": "Cha",
    "OPEN": "Vula",
    "OPEN_IN_NEW_TAB": "Vula ithebhu entsha",
    "PUBLISH": "Shicilela",
    "READ_MORE": "Buka kabanzi",
    "REJECT_ALL": "Lahla konke",
    "SAVE": "Londoloza",
    "SETTINGS": "Izilungiselelo",
    "SKIP": "Dlulisa",
    "TRANSLATE_VIA_AI": "Humusha nge-AI",
    "UPDATE": "Ushintsho",
    "UPDATE_PICTURE": "Shintsha",
    "UPLOAD_PICTURE": "Engeza isithombe",
    "VERIFY": "Hlola",
    "VERIFY_EMAIL": "Hlola ikheli lami le-imeyili",
    "VIEW_ANSWER": "Bona impendulo",
    "VIEW_IDEAS": "Buka izipho.",
    "VOTE": {
      "BUDGET": "Ngiyasekela",
      "NOT_SUPPORT": "Angisekeli",
      "SUPPORT": "Ngiyaweseka",
      "TOAST": {
        "CANCEL": "Ivoti yakho isusiwe ngempumelelo",
        "SUCCESS": "Ivoti lakho selibhalisiwe ngempumelelo"
      },
      "VOTE_AGAINST": "Ngivota ngokumelene.",
      "VOTE_FOR": "Ngivota ku-"
    },
    "WRITE": "Bhala"
  },
  "CHILDREN_COUNT": "{count, plural, =0 {Awekho okuqukethwe} one {{count} okuqukethwe} other {{count} okuqukethwe}}",
  "COMMENTS": {
    "AUTHOR": "Umbhali",
    "CREATE": {
      "PRIVACY_WARNING": "Lo okuqukethwe kuyimfihlo. Kuphela umbhali nenhlangano ebhekiswe kuyo abangakubona.",
      "SUBMIT": "Thumela"
    },
    "CREATION": {
      "APPEND_COMMENT": {
        "IDEA": "Shiya ukuphawula komphakathi ukuze uchaze ushintsho lwesimo."
      },
      "ERROR": "Kufanele ugcwalise kahle izinkambu.",
      "PLACEHOLDER": "Umbono wakho",
      "SUCCESS_ANOMALY": "Impendulo yakho ithunyelwe.",
      "SUCCESS_DEMAND": "Impendulo yakho ithunyelwe.",
      "SUCCESS_IDEA": "Umbono wakho ushicilelwe.",
      "VALIDATE": "Qinisekisa"
    },
    "SHOW": {
      "BE_THE_FIRST_TO_COMMENT_CONSULTATION": "Yiba ngowokuqala ukuphawula!",
      "BE_THE_FIRST_TO_COMMENT_MESSAGING": "Lo msebenzisi ulindele impendulo yakho kusukela ngo-{date}.",
      "BE_THE_FIRST_TO_COMMENT_PARTICIPATION": "Yiba ngowokuqala ukuphawula!",
      "CONTRIBUTION_ENDED": "Ukubonisana sekuphelile",
      "CONTRIBUTION_ENDED_ON": "Ukubonisana kuphelile ngo-{date}",
      "CONTRIBUTION_HAS_NOT_STARTED": "Uxoxwa luqala ngo-{date}",
      "COUNT_CONSULTATION": "{count, plural, =0 {Azikho izimvo} one {{count} Umbono} other {{count} Izimvo}}",
      "COUNT_MESSAGING": "{count, plural, =0 {Akukho mpendulo} one {{count} Mpendulo} other {{count} Iziphendulo}}",
      "COUNT_PARTICIPATION": "{count, plural, =0 {Azikho izimvo} one {{count} Umbono} other {{count} Izimvo}}"
    },
    "THREAD": {
      "DELETED_COMMENT": "Lo mbhalo ususiwe.",
      "DISPLAY_CONVERSATION": "{count, plural, =0 {Azikho izimpendulo} one {Bona {count} impendulo} other {Bona {count} izimpendulo}}",
      "REPLY": "Impendulo"
    },
    "TITLE": "Amazwana"
  },
  "CONTRAST_RATIO": {
    "DESCRIPTION": "Ukuba khona kokuphambene okwanele kuvumela ukuqinisekisa izinga lokutholakala elamukelekayo kubasebenzisi bakho. Ngokuhambisana nezincomo zamazwe ngamazwe (WCAG) kanye nezo ze-Referential General d'amélioration de l'accessibilité (RGAA) sikweluleka ukuthi ukhethe umbala onokuphambene okungenani {ratio}:1 (okuhambisana nezinga le-AA le-WCAG standard version 2.1)",
    "TEXT": {
      "BAD": "Izinga lokuhlukahluka kombala walesi sihloko ngu-{value}:1, futhi alihambisani nezimfuneko zokufinyeleleka (WCAG izinga AA).",
      "GOOD": "Izinga lokuhlukahluka kombala okhishiwe yi-{value}:1 futhi lihambisana nezincomo zokufinyeleleka (WCAG level AA)"
    }
  },
  "COOKIES_SETTINGS": {
    "SSO_AUTH_MODAL": {
      "CONTENT": "{providerName} uzobeka amakhukhi kudivayisi yakho uma usebenzisa lesi sici."
    },
    "VIDEO_PLACEHOLDER": {
      "ADS_BLOCK": "Uyenze kusebenze isivimbelo sokukhangisa esivimba ukuboniswa kwaleli vidiyo. Sicela usivule ukuze uqhubeke.",
      "CTA": "Yamukela amakhukhi",
      "VIMEO": "U-Vimeo ufuna ukufaka amakhukhi ukuze abonise ividiyo.",
      "YOUTUBE": "I-Youtube ifuna ukufaka amakhukhi ukuze ibonise ividiyo."
    }
  },
  "DASHBOARD": {
    "BUTTONS": {
      "EXPORT": {
        "CONSULTATION": "Ngaphandle kokuthumela izipho",
        "MESSAGING": "Thumela ngaphandle",
        "PARTICIPATION": "Thumela ngaphandle"
      }
    },
    "COUNTERS": {
      "ASSIGNMENT": "{count, plural, =0 {Azikho izabelo} one {{count} Isabelo} other {{count} Izabelo}}",
      "COMMUNICATION": "{count, plural, =0 {Azikho izindaba} one {{count} Isindaba} other {{count} Izindaba}}",
      "CONSULTATION": "{count, plural, =0 {Azikho izeluleko} one {{count} Iseluleko} other {{count} Izeluleko}}",
      "FOLDER": "{count, plural, =0 {Azikho izindaba} one {{count} Iindaba} other {{count} Izindaba}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Akukho okuqukethwe} one {{count} Okuqukethwe} other {{count} Okuqukethwe}}",
      "FORM_RESPONSES": "{count, plural, =0 {Azikho izimpendulo} one {{count} Imphendulo} other {{count} Izimpendulo}}",
      "INVITATIONS": "{count, plural, =0 {Azikho izimemo} one {{count} isimemo} other {{count} izimemo}}",
      "MESSAGING": "{count, plural, =0 {Akunakho okuqukethwe} one {{count} Okuqukethwe} other {{count} Izinto}}",
      "NEWSLETTERS": "{count, plural, =0 {Azikho izincwadi zezindaba} one {incwadi yezindaba eyi-{count}} other {izincwadi zezindaba ezingu-{count}}}",
      "PARTICIPATION": "{count, plural, =0 {Akunikezelo} one {{count} Unikelo} other {{count} Iminikelo}}",
      "RANKING": "Ukukleliswa kweminikelo",
      "USER": "{count, plural, =0 {Akukho msebenzisi} one {{count} Umsebenzisi} other {{count} Abasebenzisi}}",
      "VOTERS": "{count, plural, =0 {Akukho ovotayo} one {{count} Ovotayo} other {{count} Ovotayo}}"
    },
    "COUNTERS_SELECTED": {
      "COMMUNICATION": "{count, plural, =0 {Azikho izindaba ezikhethiwe} one {{count} Izindaba ezikhethiwe} other {{count} Izindaba ezikhethiwe}}",
      "CONSULTATION": "{count, plural, =0 {Azikho izeluleko ezikhethiwe} one {{count} Izeluleko ezikhethiwe} other {{count} Izeluleko ezikhethiwe}}",
      "FOLDER": "{count, plural, =0 {Awekho amafayela akhethiwe} one {{count} Ifayela elikhethiwe} other {{count} Amafayela akhethiwe}}",
      "FOLDER_CONTENT": "{count, plural, =0 {Awekho okuqukethwe okukhethiwe} one {{count} Okuqukethwe okukhethiwe} other {{count} Okuqukethwe okukhethiwe}}",
      "MESSAGING": "{count, plural, =0 {Akukho okuqukethwe okukhethiwe} one {{count} Okuqukethwe okukhethiwe} other {{count} Okuqukethwe okukhethiwe}}",
      "PARTICIPATION": "{count, plural, =0 {Akukho mnikelo okhethiwe} one {{count} Umnikelo okhethiwe} other {{count} Iminikelo ekhethiwe}}",
      "VOTERS": "{count, plural, =0 {Akukho ovotayo okhethiwe} one {{count} Ovotayo okhethiwe} other {{count} Ovotayo abakhethiwe}}"
    },
    "EDIT": "Ushintshi",
    "EMPTY_STATE": {
      "ASSIGNMENT": "Uzothola lapha okuqukethwe okunikezwe wena",
      "COMMUNICATION": "Shicilela isibuyekezo sakho sokuqala",
      "CONSULTATION": "Shicilela ukubonisana kwakho kokuqala",
      "FOLDER": "Dala ifolda yakho yokuqala",
      "FOLDER_CONTENT": "Uzothola lapha okuqukethwe kufolda.",
      "FORM_RESPONSES": "Nazi lapha izimpendulo zemibuzo ku-questionnaire",
      "INVITATIONS": "Uzothola lapha uhlu lwezimemo.",
      "MESSAGING": "Uzothola lapha imiyalezo nezinto ezingajwayelekile.",
      "NEWSLETTER": "Dala incwadi yakho yokuqala yezindaba",
      "PARTICIPATION": "Uzothola lapha izabelo zokubonisana",
      "SEARCH": {
        "BUTTON": "Setha kabusha izihlungi",
        "DESCRIPTION": "Qinisekisa ukuthi uwubhale kahle umbuzo wakho noma uguqule izihlungi.",
        "TITLE": "Ayikho imiphumela"
      },
      "USER": "Nansi uhlu lwabasebenzisi ababhalisile.",
      "VOTERS": "Nansi abavoti bokubonisana."
    },
    "FILTERS": {
      "ADDRESS_CITY": {
        "LABEL": "Umphakathi",
        "PLACEHOLDER": "Hlunga ngekomidi"
      },
      "BLANK": "Akukho okuqokiwe.",
      "FOLDER": {
        "LABEL": "Ifayela",
        "PLACEHOLDER": "Hlunga ngefayela"
      },
      "NEWSLETTER_STATUS": {
        "DRAFT": "Bhalwe phansi",
        "SCHEDULED": "Ihlelelwe",
        "SENT": "Kuthunyelwe"
      },
      "PROF_CATEGORY": {
        "LABEL": "Isigaba sochwepheshe emphakathini",
        "PLACEHOLDER": "Hlunga ngezigaba zomsebenzi nezenhlalo"
      },
      "REGISTERED": {
        "LABEL": "Kubhalisiwe",
        "PLACEHOLDER": "Hlunga ngokuqopha",
        "REGISTERED": "Bhalisiwe",
        "UNREGISTERED": "Angabhaliswanga"
      },
      "ROLES": {
        "ADMINISTRATOR": "Umphathi",
        "AUTHOR": "Umbhali",
        "CITIZEN": "Umsebenzisi",
        "CONTRIBUTOR": "Umphathi",
        "LABEL": "Indima",
        "PLACEHOLDER": "Hlunga ngeqhaza"
      },
      "SEX": {
        "LABEL": "Ubulili",
        "PLACEHOLDER": "Hlunga ngokwesini"
      },
      "STATUS": {
        "ANSWERED": "Ayikhishwanga",
        "DOING": "Ukuhlaziywa kuyaqhubeka",
        "DONE": "Iqedile",
        "DUPLICATE": "Iqoqwe kabusha",
        "IN_PROGRESS": "Ukuphothulwa kuqhubeka",
        "LABEL": "Isimo",
        "MESSAGING": {
          "DOING": "Ukuhlaziya kuyaqhubeka",
          "DONE": "Impendulo enikeziwe",
          "LABEL": "Isimo",
          "PLACEHOLDER": "Hlunga ngokwesimo",
          "TODO": "Ilahliwe"
        },
        "PLACEHOLDER": "Hlunga ngesimo",
        "PLANNED": "Ihlelelwe",
        "REJECTED": "Enqatshiwe",
        "SELECTED": "Ukubanjwa",
        "TODO": "Idiphozithiwe",
        "TO_MODERATE": "Ukumodareyitha",
        "VALIDATED": "Ophumelele"
      },
      "TAG": {
        "LABEL": "Indaba",
        "PLACEHOLDER": "Hlunga ngokwesihloko"
      },
      "TYPES": {
        "ANOMALY": "Imininingwane engalungile",
        "ARTICLE": "Isihloko",
        "COLLABORATIVE_DECISION": "Ukubonisana",
        "DEMAND": "Umlayezo",
        "EVENT": "Umcimbi",
        "FOLDER": "Idokhumenti",
        "IDEA": "Umnikelo",
        "IDEAS_REQUEST": "Ukubizelwa kweminikelo",
        "LABEL": "Uhlobo lokuqukethwe",
        "PARTICIPATORY_BUDGET": "Uhlelo lwezabelomali olubambisene",
        "PLACEHOLDER": "Hlunga ngohlobo",
        "STUDY": "Imibuzo",
        "SURVEY": "Inhlolovo"
      },
      "USER_TYPE": {
        "DESCRIPTION": "Ku-inthanethi noma ngaphandle kwe-inthanethi",
        "LABEL": "Ukubamba iqhaza",
        "OFFLINEUSER": "Ngaphandle kwe-inthanethi",
        "PLACEHOLDER": "Hlunga ngohlobo lokubamba iqhaza",
        "USER": "Ku-inthanethi"
      },
      "VISIBILITY": {
        "DRAFT": "Akukashicilelwa",
        "LABEL": "Ukubonakala",
        "PLACEHOLDER": "Hlunga ngokubonakala",
        "PLANNED": "Kuhlelwe",
        "PUBLISHED": "Kushicilelwe"
      }
    },
    "MANAGE_FILTERS": {
      "DESCRIPTION": "Amafayela okuhlunga agcinwe kubo bonke abalawuli nabaqondisi abagunyaziwe.",
      "NO_FILTERABLE_QUESTIONS": "Azikho izihlungi ezitholakalayo.",
      "SECTION_TITLE_FORM": "Ulwazi lwefomu",
      "SECTION_TITLE_PARTICIPANTS": "Iphrofayela yababambiqhaza",
      "TITLE": "Hlunga"
    },
    "MENU": {
      "ASSIGNMENT": "Ukuziphatha",
      "COMMUNICATION": "Izindaba",
      "CONSULTATION": "Ukubonisana",
      "FOLDER": "Amafayela",
      "GENERAL": "Jikelele",
      "MESSAGING": "Imeyili",
      "NEWSLETTER": "Izincwadi Zezindaba",
      "PARTICIPATION": "Ukubamba iqhaza",
      "SETTINGS": "Izilungiselelo",
      "SETTINGS_ACCESS": "Ukufinyelela",
      "SETTINGS_COMMUNICATION": "Ukuxhumana",
      "SETTINGS_GENERAL": "Jikelele",
      "SETTINGS_LEGAL": "Izincwadi zomthetho",
      "SETTINGS_PAGES": "Amakhasi",
      "STATS": "Ukubuka kuqala",
      "USER": "Abasebenzisi"
    },
    "NEWSLETTERS": "Izincwajana zezindaba",
    "PARTICIPATION": "Ukubamba iqhaza",
    "POSTS_FORM": {
      "FIELDS_CONFIG": {
        "ACTIVE": "Vula",
        "APPLICATION_FILE_LABEL": "Ngenisa imodeli yefayela eningiliziwe yesicelo",
        "APPLICATION_FILE_TOOLTIP": "Ukucela ulwazi olwengeziwe kubasebenzisi uma befaka isiphakamiso esisha, ungabanikeza isifanekiso sefayela esinemininingwane yokufaka isicelo.<br></br><b>Amafomethi amukelekayo:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
        "DESCRIPTION": "Ifomu lokufaka lihambisana nolwazi okumele lugcwaliswe ngumsebenzisi ukuze afake umnikelo wakhe.",
        "REQUIRED": "Kuyadingeka",
        "TITLE": "Ifomu yokufaka"
      },
      "SETTINGS_PANEL": {
        "COMMUNICATION": {
          "TITLE": "Izilungiselelo zezindaba"
        },
        "CONSULTATION": {
          "TITLE": "Izilungiselelo zeseshini yokubonisana"
        },
        "FOLDER": {
          "TITLE": "Izilungiselelo zedokhumenti"
        }
      },
      "TABS": {
        "ANALYSIS": "Hlaziya",
        "APPEARANCE": "Ukubukeka",
        "DISABLED_TOOLTIP": "Gcwalisa bese ugcine ifomu elikhona ukuze ufinyelele kulo.",
        "IMPLEMENTATION": "Imiphumela",
        "MANAGERS": "Abaphathi",
        "PRESENTATION": "Isingeniso",
        "PUBLIC_FILTERS": "Izihlungi zomphakathi",
        "QUESTIONS": "Imibuzo",
        "SECURITY": "Ukuphepha",
        "SETTINGS": "Izilungiselelo",
        "SUBMISSION": "Idiphozi",
        "VOTE": "Vota"
      }
    },
    "PUBLIC_FILTERS": {
      "DESCRIPTION": "Faka usesho oluthuthukile ekubonisaneni kwakho ukuze uvumele abasebenzisi bakho ukuthi bahluze izabelo ekhasini lakho.",
      "TITLE": "Izihlungi zomphakathi"
    },
    "SHOW": "Buka",
    "TABLE": {
      "ARIA_LABELS": {
        "FIRST_PAGE": "Ikhasi lokuqala",
        "LAST_PAGE": "Ikhasi Lokugcina",
        "NEXT_PAGE": "Ikhasi elilandelayo",
        "PREVIOUS_PAGE": "Ikhasi elandulela."
      },
      "BUTTONS": {
        "ACTIONS": "Izenzo",
        "CHANGE_STATUS": "Shintsha isimo",
        "DELETE": "Susa"
      },
      "PAGINATION": "{from}-{to} kwe-{count}",
      "TITLES": {
        "ACTIONS": "Izenzo",
        "ASSIGNED": "Umthwalo wemfanelo",
        "AUTHOR": "Umbhali",
        "BIRTHDATE": "Usuku lokuzalwa",
        "BUDGET": "Izindleko",
        "COMMENTS_COUNT": "Amazwana",
        "COMMUNICATIONS_COUNT": "Izindaba",
        "CONSULTATION": "Ukwelulekwa",
        "CONSULTATIONS_COUNT": "Imininingwane",
        "CONSULTATION_TITLE": "Isihloko sokubonisana",
        "CONTRIBUTION": "Umnikelo",
        "CREATED_AT": "Usuku lwesimemo",
        "EMAIL": "I-imeyili",
        "FIRST_NAME": "Igama lokuqala",
        "FOLDER": "Ifayela",
        "FOLDERS_COUNT": "Amadokhumenti",
        "HAS_ACCESS": "Ukufinyelela?",
        "ID": "ID",
        "IDEAS_COUNT": "Iminikelo",
        "LAST_NAME": "Igama",
        "LAST_VOTE_AT": "Usuku lokuvota",
        "NEWSLETTER_CREATED_AT": "Usuku lokudala",
        "NEWSLETTER_SENT_AT": "Usuku lokuthumela",
        "NEWSLETTER_SUBJECT": "Isihloko",
        "NEWSLETTER_TITLE": "incwadi yezindaba",
        "PARTICIPATION_TYPE": "Ukubamba iqhaza",
        "PICTURE": "Beka.",
        "PUBLICATION_DATE": "Kushicilelwe ku-",
        "RECIPIENTS": "Abamukeli",
        "RESPONSE_DATE": "Usuku",
        "ROLE": "Indima",
        "SENT_AT": "Usuku lokuthumela",
        "SOURCE": "Ukubamba iqhaza",
        "STATE": "Isimo",
        "STATUS": "Isimo",
        "SUBSCRIPTION_DATE": "Usuku lokubhalisa",
        "TITLE": "Isihloko",
        "TOPIC": "Indikimba",
        "TYPE": "Uhlobo",
        "USER": "Umsebenzisi",
        "VISIBILITY": "Ukubonakala",
        "VOTES_AGAINST_COUNT": "Amavoti amelana nawo",
        "VOTES_COUNT": "Inani lamavoti",
        "VOTES_FOR_COUNT": "Amavoti okuvuna"
      }
    }
  },
  "DATE": {
    "INPUT_FORMAT": "DD/MM/YYYY"
  },
  "DATE_TIME": {
    "DAYS_LEFT": "{count, plural, =0 {Usuku lokugcina !} one {Kusele {count} usuku !} other {Kusele {count} izinsuku !}}",
    "INVALID_LABEL": "Ayikho emthethweni",
    "IN_N_DAYS": "Ukuqala {count}",
    "LABEL": {
      "DEFAULT": "Khetha usuku",
      "SCHEDULE_LABEL": "Shicilela ku",
      "SCHEDULE_TITLE": "Hlela Ukushicilelwa"
    }
  },
  "DISCUSSION": {
    "EMAIL": {
      "CONTENT": {
        "LABEL": "Okuqukethwe kwe-imeyili",
        "PLACEHOLDER": "Sawubona, …"
      },
      "DELETED_USER_WARNING": "Lo msebenzisi ufuna ukususa i-akhawunti yakhe. Awukwazi ukuxhumana naye.",
      "SEND": "Thumela",
      "SUBJECT": {
        "LABEL": "Isihloko se-imeyili",
        "PLACEHOLDER": "Isicelo solwazi oluthe xaxa mayelana no …"
      }
    },
    "SHOW": {
      "COMMENTS_COUNT": "{count, plural, =0 {Amanothi ayimfihlo} one {{count} Inothi eyimfihlo} other {{count} Amanothi ayimfihlo}}",
      "COMMENT_PLACEHOLDER": {
        "PRIVATE": "Engeza inothi eliyimfihlo",
        "PUBLIC": "Umbono wakho"
      },
      "INFO": "Sicela ungabhali imibono equkethe idatha ebhekwa njengobucayi.",
      "INFO_TOOLTIP": "Imvelaphi yobuhlanga noma yobuzwe, imibono yezepolitiki, ifilosofi noma yezinkolo, ubulungu benyunyana, idatha yezempilo, ukukhethwa kobulili, irekhodi lobugebengu, …",
      "NO_COMMENTS": "Yiba ngowokuqala ukubhala inothi eliyimfihlo"
    }
  },
  "DUPLICATED_POSTS": {
    "TITLE": "{count, plural, =0 {# iminikelo efanayo ehlangene nalena} one {{count} umnikelo ofanayo ehlangene nalena} other {{count} iminikelo efanayo ehlangene nalena}}"
  },
  "ERROR_PAGES": {
    "BACK_TO_SPACE": "Buyela ekhasini eliyisiqalo",
    "CTA_NO_SPACE": "Thola indawo yokubamba iqhaza",
    "FORMER_CLIENT_TOAST": "Isikhala ozama ukusivakashela asikho noma asisekho.",
    "NOT_FOUND": {
      "DESCRIPTION": "Kubonakala sengathi sikuholele endleleni engafanele. Siqale phansi kahle?",
      "TITLE": "Uxolo, asikwazanga ukuthola ikhasi obulifunayo."
    },
    "OFFLINE": {
      "DESCRIPTION": "Kubonakala sengathi awuxhunyiwe ku-inthanethi. Siqale ngokuvuselela?",
      "TITLE": "Uxolo, asikwazanga ukuthola ikhasi obulifunayo."
    },
    "RELOAD": "Buyekeza",
    "SERVER_ERROR": {
      "DESCRIPTION": "Qiniseka ukuthi onjiniyela bethu benza konke okusemandleni ukusilungisa. Kufanele sibe sesibuya maduze.",
      "TITLE": "Uxolo, kwenzeke iphutha elingalindelekile."
    }
  },
  "FOOTER": {
    "ACCESSIBILITY": "Ukufinyeleleka",
    "ETHICAL_POLICY": "Isimiso sokuziphatha",
    "HELP": "Usizo",
    "LEGAL_NOTICE": "Izaziso Esemthethweni",
    "PRIVACY_POLICY": "Inqubomgomo Yobumfihlo",
    "TERMS_OF_USE": "Imibandela Yokusebenzisa"
  },
  "FORM": {
    "ERRORS": {
      "FILL_CORRECTLY": "Kufanele ugcwalise izinkambu ngendlela efanele.",
      "REQUIRED": "Kufanele ugcwalise le nkambu."
    },
    "SELECT_EMPTY_LABEL": "Akunqunyelwe",
    "TOASTS": {
      "DELETED_SUCCESSFULLY": "Ukususwa kuphumelele ngempumelelo",
      "UPDATED_SUCCESSFULLY": "Ukubuyekezwa kwenziwe ngempumelelo"
    }
  },
  "FORM_RESPONSES": {
    "CREATED_AT": "KuPhenduliwe ngo-<b>{date}</b> ngo-<b>{time}</b>",
    "SHOW_RESPONSE": "Buka impendulo yami",
    "SUBMISSION_NOT_ONGOING": "Uxoxiswano luvaliwe, awusenakuphendula noma uguqule impendulo yakho.",
    "UPDATE_RESPONSE": "Lungisa impendulo yami"
  },
  "GENERIC_CONFIRM_DELETE": {
    "CONTENT": "Uqinisekile ukuthi ufuna ukususa le nto?",
    "CTA": "Yebo, susa",
    "TITLE": "Susa"
  },
  "HOME": {
    "PAGE_TITLE": "Siyakwamukela ku-Fluicity Engage",
    "SEARCH_PLACEHOLDER": "Faka igama lesikhala",
    "SUBTITLE": "Thola indawo ukuze uqale ukubamba iqhaza"
  },
  "IMAGE": {
    "FAILED_TO_LOAD": "Yehlulekile ukulayisha isithombe",
    "LOADING": "Ukulayishwa kwesithombe"
  },
  "IMPORT": {
    "CONTRIBUTIONS": {
      "HEADLINE": {
        "DESCRIPTION": "Ukungeza iminikelo eminingi eyamukelwe ngaphandle kwepulatifomu, {link} ngaphandle kokushintsha ifomethi yayo.<br></br>Uma ungazitholanga ezinye izinkcukacha, sicela ungazisusi izinsika futhi uzishiye zingenalutho.<br></br>Uma iminikelo yakho ingezilimi eziningi, sicela uyiguqulele yonke ku-{defaultLang} ngaphambi kokuyingenisa.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa iminikelo"
      },
      "STATUS": {
        "DESCRIPTION": "Ukubonisa isimo sezigcawu ngesikhathi sokungenisa",
        "TITLE": "Khetha isimo"
      }
    },
    "ERROR": {
      "DESCRIPTION": "Ngiyaxolisa, ngikuthumele impendulo engalungile. Nansi inguqulo efanele yesiZulu:\n\nAkukwazeki ukungenisa ifayela lakho. Qinisekisa ukuthi ifayela lakho lihambisana nesibonelo.",
      "EXPLANATION": "Qinisekisa ukuthi akukho mkoloni osusiwe futhi izimpendulo ziyahambisana nefomethi ecelwe.",
      "ROWS_MULTIPLE": "Angikwazanga ukungenisa ifayela lakho. Kutholakale amaphutha kulayini {rows}.",
      "ROWS_SINGLE": "Imposibele yokungenisa ifayela lakho. Kutholakale iphutha kulayini {rows}.",
      "ROWS_WITH_MORE": "Ngiyaxolisa, kodwa akungenzeka ukungenisa ifayela lakho. Kutholakale amaphutha emigqeni {rows} kanye {moreCount} eminye."
    },
    "FORM": {
      "CTA": "Ngenisa",
      "UPLOAD_DATE": "{size} - Kubuyekeziwe ngo-{date}",
      "UPLOAD_TITLE": "Hudula ifayela noma uchofoze"
    },
    "FORM_RESPONSES": {
      "HEADLINE": {
        "DESCRIPTION": "Ukungeza izimpendulo eziningi ezitholwe ngaphandle kwepulatifomu, {link} ngaphandle kokuguqula ifomethi yazo.<br></br>Uma ungazitholanga ezinye izimpendulo, sicela ungazisusi izinsika bese uzishiya zingenalutho.<br></br>Uma izimpendulo zakho zikhona ngezilimi eziningi, sicela uzihumushe zonke zibe ngu-{defaultLang} ngaphambi kokuzifaka.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa izimpendulo"
      }
    },
    "PREVIEW": {
      "DESCRIPTION": "Qinisekisa ukuthi ulwazi olungenisiwe luhambisana namakholomu wesifanekiso.<br></br>Uma ulwazi oluthile lungahambisani, kufanele ulungise ifayela lakho bese ulithumela kabusha ifayela elibuyekeziwe.",
      "TITLE": "Hlola idatha"
    },
    "PROGRESS": "Ukungeniswa kuyaqhubeka…",
    "VOTERS": {
      "HEADLINE": {
        "DESCRIPTION": "Ukufaka amavoti atholakele ngaphandle kwepulatifomu, {link} ngaphandle kokushintsha ifomethi yawo. Uma ungawatholanga amanye amaqoqo alwazi, sicela <b>ungasusi amakholomu</b> bese uwashiya engenalutho.",
        "LINK": "gcwalisa imodeli",
        "TITLE": "Ngenisa amavoti"
      }
    }
  },
  "JOIN": "Joyina",
  "JOINED_SPACE": "Usungenile ku-{space}, wamukelekile!",
  "KEEP_ME_ALIVE": {
    "ALERT": {
      "CONTENT": "Sizokwaziswa uma noma yiziphi izeluleko ezibalulekile ngawe ziqhubeka zisakazwa esikhathini esizayo. Ungaphinde uthole ezinye izikhala ezikhona ngokusebenzisa usesho olungezansi futhi uxhumane usebenzisa i-akhawunti yakho yamanje.",
      "CONTENT_NOT_FOUND": "Ukuze ubambe iqhaza futhi ocwaningweni, sicela udale kabusha i-akhawunti.",
      "TITLE": "Ngiyabonga ngokukhetha ukugcina i-akhawunti yakho isebenza!",
      "TITLE_NOT_FOUND": "I-akhawunti yakho ayisekho noma isivele yenziwe yaba ngeyokungaziwa!"
    }
  },
  "LOADING_MORE": "Ilayisha…",
  "LOAD_MORE": "Buka okuningi",
  "MENU_ITEMS": {
    "DESCRIPTION": "Lungiselela amathebhu aveza kubha yakho yokuzulazula.",
    "FORM": {
      "ADD_ITEM": "Engeza ithebhu",
      "ADD_SUBITEM": "Engeza ithebhu engezansi",
      "INPUTS": {
        "LABEL": {
          "LABEL": "Isihloko",
          "PLACEHOLDER": "Khombisa isihloko sethebhu yakho"
        },
        "LINK": {
          "LABEL": "Isixhumanisi sangaphandle",
          "PLACEHOLDER": "https://site.com"
        },
        "PAGE": {
          "LABEL": "Ikhasi elizenzakalelayo",
          "PLACEHOLDER": "Khetha ikhasi"
        },
        "POST": {
          "LABEL": "Okuqukethwe",
          "NO_OPTIONS": "Ayikho okuqukethwe okutholiwe",
          "PLACEHOLDER": "Sesha okuqukethwe"
        },
        "POST_CATEGORY": {
          "COMMUNICATION": "Izindaba",
          "CONSULTATION": "Ukubonisana",
          "FOLDER": "Ifayela",
          "LABEL": "Uhlobo lokuqukethwe",
          "PLACEHOLDER": "Khetha uhlobo lokuqukethwe"
        },
        "TYPE": {
          "LABEL": "Uhlobo",
          "PLACEHOLDER": "Khetha uhlobo"
        }
      }
    },
    "GROUP": "Imenyu yokudonsa phansi",
    "LINK": "Isixhumanisi esingaphandle",
    "NEW_GROUP": "IMENYU ELISHA ELIHLAKANIPILEYO",
    "NEW_ITEM": "INTO ENCAZA",
    "PAGE": "Ikhasi elizenzakalelayo",
    "PAGE_ABOUT": "Mayelana",
    "PAGE_CONSULTATIONS": "Izinkulumo",
    "PAGE_NEWS": "Izindaba",
    "PAGE_SEARCH": "Sesha",
    "POST": "Okuqukethwe",
    "TITLE": "Ibhodi yakho yokuzulazula"
  },
  "MESSAGING_BLOC": {
    "ANOMALY": {
      "REPORT_CTA": "Bika iphutha"
    },
    "DEMAND": {
      "REPORT_CTA": "Thumela umlayezo"
    }
  },
  "META_TAGS": {
    "DEFAULT_DESCRIPTION": "I-Fluicity Engage iyisixazululo sokuzibandakanya kwezizwe, esivumela ukuthathwa kwezinqumo ngokuhlanganyela mayelana nezindaba ezithokozisa umphakathi.",
    "PAGES_TITLES": {
      "ABOUT": "Mayelana | {spaceName}",
      "CONSULTATIONS": "Consultations | {spaceName}",
      "CONTRIBUTIONS": {
        "MESSAGING": "Imilayezo Yami & Iziphene | {spaceName}",
        "PROPOSALS": "Iminikelo Yami | {spaceName}"
      },
      "DASHBOARD": "Ibhodi lokulawula | {spaceName}",
      "LEGAL_NOTICE": "Izaziso Esemthethweni | {spaceName}",
      "NEWS": "Izindaba | {spaceName}",
      "PRIVACY_POLICY": "Inqubomgomo Yobumfihlo |{spaceName}",
      "SEARCH": "Ukucinga | {spaceName}",
      "SETTINGS": "I-akhawunti yami | {spaceName}",
      "TERMS_OF_USE": "Imibandela Yokusebenzisa | {spaceName}"
    },
    "STATUS_TO_SHARE": {
      "ARTICLE": "{cityName}: thola lesi sihloko ku-Fluicity Engage!",
      "EVENT": "{cityName} : hlomelani kulo mcimbi !",
      "FOLDER": "{title} {url}",
      "IDEA": "Xhasa lokhu kunikela : {title} {url}"
    },
    "TITLE_TO_SHARE": {
      "FOLDER": "{isihloko}",
      "IDEA": "Sekela le minikelo: {title}"
    }
  },
  "MODERATION": {
    "MODAL": {
      "DESCRIPTION": "Ungaguqula umnikelo wakho noma uwuthumele njengoba unjalo. Izinsiza zizohlola ukuthi umnikelo wakho ungashicilelwa yini noma cha.",
      "REASON": "Isizathu:",
      "SUBMIT": "Thumela",
      "TITLE": "Igalelo lakho litholakale njengeliyinsolo."
    }
  },
  "MOMENT": {
    "DATE": {
      "DEFAULT": "DD/MM/YYYY",
      "PLACEHOLDER": "JJ/MM/UUUU"
    }
  },
  "NAVBAR": {
    "DASHBOARD": "Ishadi lokubuka",
    "MY_ACCOUNT": "I-akhawunti yami",
    "MY_PROFILE": "Iphrofayela Yami"
  },
  "NEWSLETTERS": {
    "ALREADY_SENT": "Leli phephandaba selithunyelwe kakade.",
    "CREATED_AT": "Idalwe ngo-<b>{date}</b> nge-<b>{time}</b>",
    "DRAFT": "Umdwebo",
    "FORM": {
      "CLEAR_SCHEDULING": "Ukukhansela ukuhlela.",
      "CONTENT": {
        "LABEL": "Okuqukethwe",
        "PLACEHOLDER": "Okuqukethwe kwe-imeyili"
      },
      "RECIPIENTS": {
        "ALL": "Bonke abasebenzisi",
        "LABEL": "Abamukelwayo",
        "PLACEHOLDER": "Khetha abamukeli"
      },
      "SAVE_SUCCESS": "I-imeyili yakho yobulungu ibhaliswe ngempumelelo",
      "SCHEDULE": "Hlela ukuthumela",
      "SCHEDULED_AT": "Usuku lokuthumela",
      "SEND": "Thumela",
      "SEND_SUCCESS": "I-imeyili yakho yezindaba ithunyelwe ngempumelelo",
      "SEND_TEST": "Thumela ukuhlolwa",
      "SUBJECT": {
        "LABEL": "Isihloko",
        "PLACEHOLDER": "Isihloko se-imeyili"
      },
      "TEST_EMAIL": {
        "LABEL": "Imeyili yokuhlola",
        "PLACEHOLDER": "Faka amakheli e-imeyili okuhlola (ahlukaniswe ngamakhefana)"
      },
      "TEST_SUCCESS": "I-imeyili yakho yezindaba yokuhlola ithunyelwe ngempumelelo"
    },
    "IMMEDIATELY": "Masisha.",
    "NEW_NEWSLETTER": "Dala i-newsletter",
    "SCHEDULED": "Ihleliwe",
    "SENT": "Imininingwane ethunyelwe",
    "SENT_AT": "Ithunyelwe ngo-<b>{date}</b> ngo-<b>{time}</b>",
    "UPDATE_NEWSLETTER": "Guqula incwadi yezindaba",
    "USERS_FILTER_COUNT": "{count, plural, =0 {Akukho muntu otholiwe kulokhu okukhethile} one {Incwadi yakho yezindaba izothunyelwa kumuntu oyedwa} other {Incwadi yakho yezindaba izothunyelwa kubantu abangu-{count}}}"
  },
  "NEXT": "Okulandelayo",
  "NONE": "Akukho",
  "NOTIFICATIONS_SETTINGS": {
    "ADMINISTRATOR": {
      "DAILY_DIGEST": {
        "DESCRIPTION": "Izinkulumo :<br />• Iminikelo emisha<br />• Izimpendulo ezintsha kuziphenyo<br />• Uma isakhamuzi siphendula komunye wami amazwana<br />• Uma isigaba noma iseluleko siphetha maduze<br /><br />Imiyalezo :<br />• Imiyalezo emisha<br />• Iziphazamiso ezintsha<br />• Uma isakhamuzi siphendula komunye wami amazwana",
        "SUBTITLE": "nsuku zonke",
        "TITLE": "Imisebenzi Yakamuva"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "• Ukuguqulwa kweminikelo ngumbhali wayo<br />• Ukulawulwa kokuqukethwe yiqembu le-Fluicity Engage",
        "TITLE": "Ezinye"
      }
    },
    "CITIZEN": {
      "CONSULTATIONS_NOTIFICATIONS": {
        "DESCRIPTION": "• Ukuhlanganyela okusha<br />• Ukuqala kwesigaba sokucabanga, sokuvota noma semiphumela",
        "TITLE": "Ukubonisana"
      },
      "DAILY_DIGEST": {
        "DESCRIPTION": "• Amazwana noma ukuvota ekungenisweni kwami<br />• Impendulo kumazwana wami<br />• Ukushintsha kwesimo sokungeniswa kwami",
        "SUBTITLE": "nsuku zonke",
        "TITLE": "Imisebenzi yakho yakamuva"
      },
      "NEWSLETTER_NOTIFICATIONS": {
        "DESCRIPTION": "• Izinhlolovo mayelana nomsebenzi weplathifomu",
        "TITLE": "Izincwadi zezindaba"
      },
      "SUBSCRIBED_ACTIVITIES_NOTIFICATIONS": {
        "DESCRIPTION": "Ukususwa komnikelo owawuphawule ngawo<br />• Ukulawulwa kokuqukethwe okwakuphawuliwe nguwe",
        "TITLE": "Okunye"
      },
      "WEEKLY_DIGEST": {
        "DESCRIPTION": "• Izihloko ezintsha<br />• Izehlakalo ezintsha<br />• Iminikelo ephambili",
        "SUBTITLE": "amasonto onke",
        "TITLE": "Okwamanje endaweni"
      }
    },
    "INFO_BOX_TEXT": "Khetha lapha izaziso ze-imeyili ofuna ukuzi thola ezivela eqenjini leplathifomu."
  },
  "NPS_FORM": {
    "CONTENT_FIELD": "Kungani?",
    "EXTREMELY_LIKELY": "Impela",
    "NOT_LIKELY": "Hhayi nhlobo",
    "TITLE": "Sisiza ukuthuthukisa i-Fluicity Engage",
    "VALUE_QUESTION": "Uzincoma Fluicity Engage kumlingani?"
  },
  "OFFLINE": "Ngaphandle kwe-inthanethi",
  "ONLINE": "Ku-inthanethi",
  "OR": "OU",
  "ORIGINAL_POST": {
    "NO_OPTIONS": "Ayikho iminikelo engakhethwa",
    "TITLE": "Le minikhethelo lelihluziwe lihlanganiswe nomnikelo ofanayo olandelayo."
  },
  "PAGE_OF": "Ikhasi {current} kwaba {total}",
  "PASSWORD_RESET": {
    "ACTION": "Buyekeza",
    "ARIA_LABEL": "Shintsha ukubonakala kwephasiwedi",
    "PAGE_TITLE": "Dala iphasiwedi entsha",
    "TITLE": "Dala iphasiwedi entsha",
    "TOAST": "Iphasiwedi entsha igcinwe ngempumelelo."
  },
  "PASSWORD_RESET_REQUEST": {
    "HOMEPAGE_LINK": "Buyela ekhasini lasekhaya",
    "LINK_SENT": "Uma i-akhawunti ixhunyaniswe ne-imeyili <strong>{email}</strong>, uzothola isixhumanisi sokusetha kabusha. <br></br><br></br>Uma ungayiboni i-imeyili, hlola ku-imeyili engafuneki.",
    "PAGE_TITLE": "Setha kabusha iphasiwedi yakho.",
    "RESET": "Setha kabusha",
    "SUB_TITLE": "Ulibale iphasiwedi yakho? Kuyenzeka kubo bonke! Sizokuthumelela i-imeyili enesixhumanisi sokuyisetha kabusha.",
    "TITLE": "Setha kabusha iphasiwedi yakho"
  },
  "PICTURE_PICKER": {
    "COVER": "Khetha isithombe sokufaka esithombeni sokuthumela kwakho"
  },
  "POSTS": {
    "AUDITS": {
      "CREATE": "kwakhiwa {date}",
      "MODAL": {
        "AFTER": "Ngemuva kokuguqulwa",
        "BEFORE": "Ngaphambi kokulungiswa",
        "TITLE": "Umlando"
      },
      "NO_AUDITS": "Lokhu kunikela akukabuyekezwa okwamanje.",
      "UPDATE": "Kubuyekeziwe {date}"
    },
    "AUTHOR": "Umbhali",
    "BUDGET": {
      "ALERT": "Kufanele <b>ungenise izindleko</b> zomnikelo ngaphambi kokuwumaka ngokuthi “Retenue”.",
      "BUDGET_VALUE": "Lo mnikelo ubiza <b>{budget}</b>",
      "MODAL_LABEL": "Izindleko zomnikelo",
      "MODAL_TITLE": "Faka izindleko",
      "NOT_ENOUGH_BUDGET": "Ibhalansi yesabelomali ayenele.",
      "NOT_SELECTED": "Leli galelo alikhethwanga ukuze lidlule esigabeni sokuvota.",
      "REMAINING_BUDGET": "Usekhona <strong>{remaining}</strong> ongayisebenzisa"
    },
    "CARD": {
      "CONTRIBUTE": "Faka isandla",
      "PARTICIPATE": "Bamba iqhaza",
      "READ_MORE": "Bheka",
      "VOTE": "Votela"
    },
    "CAROUSEL": {
      "PROGRESS": {
        "TOOLTIP_1": "{progress, plural, =0 {{progress} amavoti} one {{progress} ivoti} other {{progress} amavoti}}",
        "TOOLTIP_2": "{total, plural, =0 {ngokwesamba esingu-{total} sokunikela} one {ngokwesamba esingu-{total} sokunikela} other {ngokwesamba esingu-{total} sokunikela}}"
      },
      "PROMPT": {
        "PROPOSAL_CARD": {
          "CTA": "Umnikelo",
          "TEXT_1": "Noma uma unomdlandla",
          "TEXT_2": "senza?"
        },
        "VOTE_CARD": {
          "CTA": "Vota",
          "TEXT_1": "Usuvele ubheke izindlelo ezimbalwa {emoji}",
          "TEXT_2": "siqhubeka?",
          "TEXT_3": "noma ubone uhlu oluphelele"
        }
      }
    },
    "CLONE": {
      "ACTION": "Phinda",
      "CANCEL": "Cha",
      "CONFIRM": "Yebo, kopisha.",
      "CONTENT_CLONED": "Okuqukethwe lokhu kuphindwe ngempumelelo.",
      "DESCRIPTION": "Ngabe ngempela ufuna ukukopisha lokhu okuqukethwe?",
      "SUCCESS": "Lo okuqukethwe kususiwe."
    },
    "COMMENTS_COUNT": "{count, plural, =0 {Amazwana} one {Amazwana} other {Amazwana}}",
    "CONSULTATIONS": {
      "BE_THE_FIRST_TO_PARTICIPATE": "Yiba ngowokuqala noma ngowesifazane oqala ukubamba iqhaza!",
      "CONSULTATIONS_COUNT": "{count, plural, =0 {{count} ukubonisana} one {{count} ukubonisana} other {{count} izeluleko}}",
      "ENDED_AT": "Ukubonisana kuphelile ngo-{date}",
      "FEED_TITLE": {
        "IDEAS_COUNT": "{itemCount, plural, =0 {Azikho izabelo} one {# izabelo} other {# izabelo} }",
        "LOCATED_IDEAS_COUNT": "{itemCount, plural, =0 {Azikho izipho ezitholakalayo} one {1 isipho esitholakalayo} other {# izipho ezitholakalayo}}"
      },
      "MAP_TOOLTIP": "Izethulo ezingekho ku-geolocation azibonakali kumephu. Igalelo lingaba nezindawo eziningi.",
      "NEWS_COUNT": "{count, plural, =0 {izindaba} one {{count} izindaba} other {{count} izindaba}}",
      "ONGOING_TEXT": "Hlangana lapha ukuze ubambe iqhaza.",
      "PARTICIPATE_OFF": "Hlangana lapha maduzane ukuze ube nengxenye ekufakeni isandla!",
      "POST_SIDE_PRIMARY_ACTION": {
        "IMPLEMENTATION": "Thola imiphumela",
        "PARTICIPATE": "Joyina ukubonisana"
      },
      "SEE_OWN_VOTES": "Bona kuphela amavoti ami",
      "STARTS_AT": "Ukubonisana kuzoqala ngo-{date}",
      "STEP_ENDED_AT": "Isigaba “{step}” siqediwe ngo-{date}",
      "STEP_STARTS_AT": "Sihlangane ngo-{date} ukuze uthole isiqephu “{step}”"
    },
    "CONTENT_DELETED_SUCCESSFULLY": "okuqukethwe kususiwe",
    "CREATE_MENU": {
      "ACTIONS": "Izenzo",
      "ADDED_TO_FOLDER_TOAST": "Okuqukethwe kwengezwe kufolda.",
      "ADD_TO_FOLDER": "Faka kufayela",
      "ARTICLE": {
        "DESCRIPTION": "Yethula izindaba noma umkhankaso"
      },
      "ASSIGN": "Umthumeli",
      "BUTTON": "Dala",
      "COLLABORATIVE_DECISION": {
        "DESCRIPTION": "Ukusebenzisa izabelo ezakhiwe ngokubambisana nabasebenzisi"
      },
      "CONTACT_AUTHOR": "Xhumana nombhali",
      "DIALOG_TITLE": {
        "COMMUNICATION": "Dala izindaba ezintsha",
        "CONSULTATION": "Dala ukubonisana"
      },
      "EDIT": "Mshicileli",
      "EVENT": {
        "DESCRIPTION": "Memema ukuzohlanganyela emhlanganweni"
      },
      "FOLDER": {
        "DESCRIPTION": "Dala ikhasi ukuze kuhlanganyelwe okuqukethwe."
      },
      "IDEAS_REQUEST": {
        "DESCRIPTION": "Ukuqoqa iminikelo ngamaqhaza akho amasu."
      },
      "MERGE": "Ukuhlanganisa umnikelo",
      "PARTICIPATORY_BUDGET": {
        "DESCRIPTION": "Hlela isabelomali esabelwe izabelo ezakhiwe ngokubambisana nabasebenzisi"
      },
      "PIN": "Kubonisa Okukhethekile",
      "REMOVED_FROM_FOLDER_TOAST": "Okuqukethwe kususiwe efayeleni.",
      "REPORT": "Bika",
      "STEPS_COUNT": "{count, plural, one {# isinyathelo} other {# izinyathelo}}",
      "STUDY": {
        "DESCRIPTION": "Faka uhlu olwenziwe ngaphandle kwepulatifomu",
        "TITLE": "Uphenyo - Ukuhlanganiswa"
      },
      "SURVEY": {
        "DESCRIPTION": "Cela incite les utilisateurs à réfléchir profondément et à partager des perspectives variées."
      },
      "UNPIN": "Ungabe usaqokelwa phambili",
      "UNPUBLISH": "Ukususa ekushicilelweni",
      "UPDATE_BUDGET": "Setha isabelomali",
      "UPDATE_STATUS": "Shintsha isimo",
      "VIEW": "Buka okuthunyelwe",
      "VIEW_IN_DASHBOARD": "Ishadi lokubuka",
      "VIEW_POST": "Bona okuthunyelwe"
    },
    "DELETE": {
      "ACTION": "Susa",
      "CANCEL": "Non",
      "CONFIRM": "Yebo, susa",
      "CONTENT_DELETED": "Lo okuqukethwe kususiwe.",
      "DESCRIPTION": "Ingabe ngempela ufuna ukususa lokhu okuqukethwe?",
      "PLACEHOLDER": "Engeza imibono ukuze uchaze ukususa kwakho.",
      "REASON": "Amazwana",
      "SELECT_REASON": "Sicela uchaze ukuthi kungani ususa lokhu okuqukethwe:",
      "SUCCESS": "Lokhu okuqukethwe kususiwe."
    },
    "DETAILS": {
      "AUTHORED_BY": "Igqokwe ngu-{name}",
      "DESCRIPTION_TITLE": "Incazelo",
      "EVENT": {
        "ACCESS_THE_EVENT": "Ngena emcimbini",
        "EVENT_URL": "Inkomfa yevidiyo",
        "STATE": {
          "FUTURE": "Umcimbi uqala ngo-<b>{date}</b> ngo-<b>{time}</b>.",
          "ONGOING": "Umcimbi uyaqhubeka",
          "PAST": "Umcimbi usuphelile"
        }
      },
      "MORE_TAGS": "{count, plural, one {futhi enye indaba} other {futhi {count} ezinye izindaba}}",
      "STUDY": {
        "JOIN_BUTTON": "Joyina",
        "JOIN_DESCRIPTION": "Ngena ngemvume noma ubhalise ukuze uthole ukufinyelela ekubonisaneni!",
        "PARTICIPATE": "Bamba iqhaza",
        "POST_SIDE_DESCRIPTION": {
          "COMING": "Ukubonisana kuqala nge-{date}.",
          "ENDED": "Ukubonisana kuphelile ngo-{date}.",
          "ONGOING_ANSWERED": "Ngiyabonga ngokubamba iqhaza kwakho, kuqoshiwe kahle."
        },
        "SEE_RESULTS": "Bona imiphumela"
      },
      "UPDATE_MY_IDEA": "Modyuli"
    },
    "EXPORT": {
      "BUTTON": "Ukuthekelisa",
      "IDEAS": "Zonke izabelo",
      "MESSAGES": "Wonke umlayezo"
    },
    "FILTER_BY_IS_PINNED": "Esihlokweni",
    "FILTER_BY_PUBLISHED": "Kushicilelwe",
    "FILTER_BY_STATUS": "Isimo",
    "FILTER_BY_TAGS": "Indaba enkulu",
    "FILTER_BY_TYPE": "Uhlobo lokuqukethwe",
    "FILTER_IS_PINNED_TRUE": "Yebo",
    "FILTER_PUBLISHED_FALSE": "Akukashaziwa",
    "FILTER_PUBLISHED_TRUE": "Kushicilelwe",
    "FILTER_STATUS_ANSWERED": "Akunakilekiwe",
    "FILTER_STATUS_DOING": "Ukuhlaziya kuqhubeka",
    "FILTER_STATUS_DONE": "Iyaphumelela",
    "FILTER_STATUS_IN_PROGRESS": "Ukuphothulwa kuyenzeka",
    "FILTER_STATUS_SELECTED": "Retenue",
    "FILTER_STATUS_TODO": "Idiphozithiwe",
    "FILTER_STATUS_VALIDATED": "Umpetha wesifazane",
    "FILTER_TYPE_ANOMALY": "Iphutha",
    "FILTER_TYPE_ARTICLE": "I-Article",
    "FILTER_TYPE_COLLABORATIVE_DECISION": "Ukuxoxisana",
    "FILTER_TYPE_DEMAND": "Umlayezo",
    "FILTER_TYPE_EVENT": "Umcimbi",
    "FILTER_TYPE_FOLDER": "Idokhumenti",
    "FILTER_TYPE_IDEA": "Umnikelo",
    "FILTER_TYPE_IDEAS_REQUEST": "Ukubizelwa kwezimali",
    "FILTER_TYPE_PARTICIPATORY_BUDGET": "Isabelomali elihlanganyelwayo",
    "FILTER_TYPE_STUDY": "Umbuzo",
    "FOLDER": {
      "IS_OPEN_TO_PROPOSITIONS": "Vuleleke ekunikeleni okungahleliwe"
    },
    "FORM": {
      "ADDRESS": {
        "LABEL": "Indawo",
        "PLACEHOLDER": "Engeza indawo"
      },
      "CATEGORIES": {
        "LABEL": "Izihloko",
        "PLACEHOLDER": "Khetha izihloko zokubonisana",
        "SELECT_ALL": "Khetha konke"
      },
      "CATEGORY": {
        "LABEL": "Izihloko",
        "PLACEHOLDER": "Khetha isihloko"
      },
      "CONTENT": "Incazelo",
      "PICTURE": {
        "BUTTON": {
          "ADD_FILE_OR_PICTURE": "Engeza ifayela/isithombe",
          "ADD_PICTURE": "Engeza isithombe",
          "DELETE_PICTURE": "Susa"
        },
        "ERRORS": {
          "FILE_SIZE": "Usayizi wesithombe akumele udlule {fileSize}Mo.",
          "FILE_TYPE": "Isithombe kufanele sibe ngefomethi {fileTypes}."
        },
        "TOOLTIP": "<b>Usayizi onconyiwe:</b> {width} (ububanzi) ngo-{height} amaphikseli (ubude) <br></br> <b>Amathuluzi amukelekayo:</b> .jpg, .jpeg, .png"
      },
      "PIN": "Lo okuqukethwe kugqanyisiwe.",
      "TITLE": "Isihloko",
      "UNPIN": "Lo mongo awusekho esihlokweni."
    },
    "HOW_IT_WORKS": {
      "TITLE": "Kusebenza kanjani?"
    },
    "INDICATORS": {
      "ATTENDEES": "Abahlanganyeli",
      "COMMENTS": "Amazwana",
      "COMMUNICATIONS": "Izindaba",
      "CONSULTATIONS": "Ukubonisana",
      "IDEAS": "Iminikelo",
      "VOTES": "{online_count, plural, =0 {{online_count} amavoti aku-inthanethi} one {{online_count} ivoti eku-inthanethi} other {{online_count} amavoti aku-inthanethi}} - {offline_count, plural, =0 {{offline_count} amavoti angaxhunyiwe ku-inthanethi} one {{offline_count} ivoti engaxhunyiwe ku-inthanethi} other {{offline_count} amavoti angaxhunyiwe ku-inthanethi}}"
    },
    "INTERACTIONS_BOX": {
      "CONTINUE_CONVERSATION": "Qhubeka nengxoxo",
      "GIVE_YOUR_OPINION": "Nikeza umbono wakho"
    },
    "PREVIEW": "Buka kuwebhusayithi",
    "PUBLIC_STUDY": "Ucwaningo lomphakathi",
    "PUBLISHED": "Kushicilelwe(i)",
    "PUBLISHED_AT": "Kukhishwe ngo-{date}",
    "PUBLISH_CANCELED": "Ukushicilelwa kwalolu hlelo kuhanjiswe phambili.",
    "PUBLISH_EDIT": "Hlela ukuhlela kwamasu",
    "PUBLISH_NOW": "Shicilela manje",
    "PUBLISH_NOW_TOASTER": "Okuqukethwe kwakho manje sekubonakala kubasebenzisi",
    "PUBLISH_SCHEDULED": "Hlela Ukushicilelwa",
    "REPORT": {
      "ACTION": "Bika",
      "CODE_OF_ETHICS": "umthetho wokuziphatha",
      "CONFIRM": "Thumela",
      "EMPTY_ERROR": "Kufanele ugcwalise izinkambu kahle.",
      "FLUICITY_TERMS_PART_A": "Funda kabanzi ngezinto ezithile",
      "FLUICITY_TERMS_PART_B": "futhi i",
      "FLUICITY_TERMS_PART_C": "de Fluicity Engage.",
      "PLACEHOLDER": "Faka amazwana ukuze uchaze imininingwane yesaziso sakho.",
      "SELECT_REASON": "Sicela uchaze ukuthi kungani ubika loku okuqukethwe:",
      "SUCCESS": "Ngiyabonga ngalokhu kubika. Kusisiza ekuqinisekiseni okuqukethwe kwekhwalithi ku-Fluicity Engage.",
      "TERMS_OF_USE": "Imigomo Nemibandela Ejwayelekile"
    },
    "RESPONSES_COUNT": "{count, plural, =0 {Impendulo} one {Impendulo} other {Izimpendulo}}",
    "SAVE": "Londoloza",
    "SAVE_THE_DRAFT": "Londoloza uhlaka olusalungiswa",
    "SCHEDULE": "Uhlelo lokusebenza",
    "SCHEDULED": "Kuhleliwe",
    "SCHEDULED_AT": "Kuhlelwe ngo-{date}",
    "SCHEDULED_AT_TOASTER": "Okuqukethwe lokhu kuhlelelwe ukuba kushicilelwe ngo-{date}",
    "SEE": {
      "COLLABORATIVE_DECISION": "Bheka ukuxoxisana",
      "FOLDER": "Bona ifolda",
      "IDEA": "Buka umnikelo",
      "IDEAS_REQUEST": "Bona isicelo sokufaka izethulo",
      "PARTICIPATORY_BUDGET": "Bheka uhlahlo lwabiwo-mali lokubambisana"
    },
    "SHOW": {
      "FROM_DATE_TO_DATE_WITH_TIME": "Kusukela <strong>{startAtDate} ngo-{startAtHour}</strong> kuya ku-<strong>{endAtDate} ngo-{endAtHour}</strong>",
      "QR_CODE": {
        "BLACK_AND_WHITE": "Mnyama nomhlophe",
        "DOWNLOAD": "Landa",
        "GENERATE": "Khulisa i-QR code",
        "TITLE": "QR Ikhodi"
      },
      "SHARE_IT": "Yabelana"
    },
    "SORT": {
      "BUTTON": "Hlunga",
      "POPULAR": "Kudumile",
      "RECENT": "Muva"
    },
    "STATS": {
      "TITLE_PARTICIPATION": "Isifinyezo sokubamba iqhaza"
    },
    "STATUS": {
      "FORM_TITLE": "{count, plural, =0 {Shintsha isimo} one {Shintsha isimo} other {Shintsha isimo: {count} iminikelo ekhethiwe}}",
      "MODAL": {
        "TITLE": "Ukuthuthuka kokufaka isandla"
      },
      "ORIGINAL_POST": {
        "LABEL": "Isihloko somnikelo wokuqala ozogcinwa.",
        "TITLE": "Faka isihloko sokufaka kwasekuqaleni lapho uzohlanganisa khona lokhu kufaka:"
      },
      "POPOVER": {
        "BUTTON": "Funda kabanzi"
      },
      "SUBMIT": "Londoloza",
      "TITLE": "Isimo",
      "UPDATED_SUCCESSFULLY": "Isimo silondoloziwe."
    },
    "STEPS": {
      "STATES": {
        "AVAILABLE": "Kuyatholakala",
        "COMING": "Ezayoza",
        "ENDED": "Isiphelile",
        "ENDLESS": "Kuqhubeka",
        "ONGOING": "Kuyaqhubeka"
      },
      "TABS": {
        "LABEL": "Amathebhu okukhetha izigaba zokushicilela"
      }
    },
    "SUMMARY": {
      "TITLE": "Isifinyezo somnikelo",
      "TOOLTIP": "Lo mfingqo wenziwe ngosizo lobuhlakani bokufakelwa ukuze kube lula ukufunda igalelo lakho."
    },
    "TAGS": {
      "PERIOD": "Kusuka <strong>{startAtDate} ngo-{startAtHour}</strong> kuya ku-<strong>{endAtDate} ngo-{endAtHour}</strong>",
      "PERIOD_SAME_DAY": "Ngo-<strong>{startAtDate}</strong> kusukela ngo-<strong>{startAtHour}</strong> kuya ku-<strong>{endAtHour}</strong>",
      "PERIOD_SHORT": "Kusukela <strong>{startAtDate}</strong> kuya ku-<strong>{endAtDate}</strong>"
    },
    "TYPES": {
      "ANOMALY": "Iphutha",
      "ARTICLE": "I-athikhili",
      "COLLABORATIVE_DECISION": "Ukubonisana",
      "DEMAND": "Umyalezo",
      "EVENT": "Umcimbi",
      "FOLDER": "Dossier",
      "IDEA": "Umnikelo",
      "IDEAS_REQUEST": "Ukubizelwa kwemibono",
      "PARTICIPATORY_BUDGET": "Uhulumeni wobambiswano lwezimali",
      "STUDY": "Inhlolovo",
      "SURVEY": "Uhlu lwemibuzo"
    },
    "UPDATED": "Okuqukethwe kubuyekeziwe ngempumelelo"
  },
  "POST_FORM": {
    "ACTION_SAVE": "Londoloza",
    "ADMIN_UPDATE_ALERT": "Uma ususa umnikelo, sithumela ngokuzenzakalelayo isaziso nge-imeyili kumbhali wayo. Ukuqinisekisa ukuthi umbhalo uyavumelana noshintsho lwakho, sincoma ukuthi uxhumane naye ngokuqondile kusengaphambili.",
    "APPLICATION_FILE": "Letha ifayela lakho elinemininingwane yohlelo lokusebenza.",
    "APPLICATION_FILE_BUTTON": "Engeza ifolda",
    "APPLICATION_FILE_TOOLTIP": "Ukuthumela umnikelo wakho, kufanele unikeze ifayela elinemininingwane yefomu lokufaka isicelo. Ukuze wenze lokhu, gcwalisa isifanekiso esinikeziwe bese usibeka ngezansi.<br></br><br></br Ngokuphambene nolwazi olunikezwe kuzo zonke izinkambu zefomu (isihloko, incazelo, isihloko, njll.) ezizoba zomphakathi, okuqukethwe kwefayela kuzotholakala kuphela ngabaphathi beplathifomu.<br></br><br></br><b>Amafomethi amukelekile:</b> .pdf, .doc, .docx, .txt, .odt, .rtf, .md",
    "ATTACHMENTS": {
      "DESCRIPTION": {
        "COMMUNICATION": "Yabelana amadokhumenti angeziwe afana nezithombe noma ividiyo ezindabeni zakho.",
        "CONSULTATION": "Yabelana ngemibhalo eyengeziwe efana nemithetho yakho, izithombe noma ividiyo ngesikhathi sokubonisana kwakho.",
        "FOLDER": "Yabelana ngamaphepha engeziwe anjengamafotho noma ividiyo kufayela lakho."
      },
      "TITLE": "Izithasiselo"
    },
    "ATTACHMENTS_FILES": "Amafayela",
    "ATTACHMENTS_IMAGES": "Izithombe",
    "ATTACHMENTS_TITLE": "Amadokhumenti",
    "AUTHORED_BY": "Ubani umbhali?",
    "AUTHORED_BY_A_THIRD_PARTY": "Umuntu wesithathu",
    "AUTHORED_BY_A_THIRD_PARTY_PLACEHOLDER": "Umuntu ongaphandle kwepulatifomu",
    "AUTHORED_BY_CUSTOM": "Ngokwezifiso",
    "AUTHORED_BY_CUSTOM_PLACEHOLDER": "Inhlangano, iqembu lezakhamuzi, umhlangano…",
    "AUTHORED_BY_FIRST_NAME": "Igama lombhali",
    "AUTHORED_BY_FIRST_NAME_PLACEHOLDER": "Isibonelo: UJean",
    "AUTHORED_BY_LAST_NAME": "Igama lombhali",
    "AUTHORED_BY_LAST_NAME_PLACEHOLDER": "Isibonelo: Dupont",
    "AUTHORED_BY_MYSELF": "Mina uqobo",
    "AUTHORED_BY_MY_SPACE": "Inhlangano yami",
    "BUDGET": "Isabelwe yesabelomali",
    "BUDGET_PLACEHOLDER": "Shiya isabelomali semali",
    "CHOOSE_A_FOLDER": "Khetha ifolda",
    "CONTENT": "Incazelo",
    "CONTRIBUTION_KIND": {
      "CUSTOM_LABEL": "Uhlobo lomnikelo",
      "CUSTOM_PLACEHOLDER": "Khombisa uhlobo lwezimali ofuna ukuzibutha.",
      "DESCRIPTION": "Lungisa ilebula lenkinobho (CTA) yokufaka iminikelo.",
      "OPTIONS": {
        "CONTRIBUTION": "Umnikelo",
        "OTHER": "Okunye",
        "PROPOSAL": "Isiphakamiso",
        "QUESTION": "Umbuzo",
        "REPORT": "Ukubika"
      },
      "PREVIEW": "Sibutsetfo:",
      "TITLE": "Uhlobo lomnikelo"
    },
    "DEFAULT_PROPOSAL_VIEW": {
      "OPTIONS": {
        "CAROUSEL": {
          "DESCRIPTION": "Ukukhuthaza ukusabela (ukuvota okuvuna noma okuphikisa)",
          "NAME": "Ishashalazi"
        },
        "LIST": {
          "DESCRIPTION": "Ukuze ubonise konke okuhlanganyelwe ngendlela elula.",
          "NAME": "Uhlu"
        },
        "MAP": {
          "DESCRIPTION": "Ukuba nombono wezindawo ngeminikelo",
          "NAME": "Imephu"
        }
      },
      "SUBTITLE": "Lungisa ikhasi lokubonisana kwakho ngokukhetha ukubuka okuzenzakalelayo kweminikelo. Kunoma yikuphi, abasebenzisi bazokwazi ukukhetha ukubuka okuhlukile.",
      "TITLE": "Ukuboniswa kwezimisebenzi ezibekwe esidlangalaleni"
    },
    "DESCRIPTION": "Incazelo",
    "DESCRIPTION_SECTION": {
      "DESCRIPTION": {
        "COMMUNICATION": "Lesi sigaba likuvumela ukuthi uchazele abasebenzisi isizinda nezinto ezibalulekile zezindaba zakho.",
        "CONSULTATION": "Lesi sigaba likuvumela ukuthi uchazele abasebenzisi isimo kanye nemininingwane yokubonisana kwakho.",
        "FOLDER": "Lesi sigaba likuvumela ukuba uchazele abasebenzisi umongo kanye nezindaba ezibalulekile zedokhumenti yakho."
      },
      "TITLE": "Incazelo yenqubo"
    },
    "DISPLAY_OPTIONS": {
      "CHILDREN_LIST_PICTURES": {
        "LABEL": "Bonisa izithombe zeqhaza ohlwini",
        "TITLE": "Isithombe"
      },
      "COMMENTS_ENABLED": {
        "LABEL": "Vula ukuphawula ngaphansi kocwaningo lwakho"
      },
      "GEOJSON": {
        "DESCRIPTION": "Lungisa imephu ngezindawo zezwe nezindawo ezithakazelisayo ku-{link} bese unamathisela ikhodi engezansi.",
        "TITLE": "Yenza ngokwezifiso imephu"
      }
    },
    "EDIT": {
      "TITLE": {
        "ANOMALY": "Lungisa iphutha",
        "COMMUNICATION": "Shintsha izindaba zakamuva",
        "CONSULTATION": "Shintsha ukubonisana",
        "DEMAND": "Lungisa umlayezo",
        "FOLDER": "Lungisa ifolda",
        "IDEA": "Shintsha umnikelo"
      }
    },
    "EDITORS_FORM": {
      "DESCRIPTION": "Ukuze unikeze umsebenzisi ukufinyelela, kufanele abe <i>Umphathi</i> wesikhala. Kuphela <i>Umlawuli</i> ongayinika le ndima.",
      "SUBTITLE": "Uhlu lwabasebenzisi abanokufinyelela ekuphatheni kwalesi sixoxo.",
      "TITLE": "Abaphathi"
    },
    "END_AT": "Usuku nesikhathi sokuphela",
    "ERRORS": {
      "FILL_FIELDS": "Kufanele ugcwalise izinkambu ngokufanele.",
      "LOCATION_NOT_IN_THE_LIST": "Kufanele ukhethe ikheli ohlwini."
    },
    "EVENT_URL_LABEL": "Ingqungquthela yevidiyo",
    "EVENT_URL_PLACEHOLDER": "Faka i-URL ye-visioconférence ye-Zoom, Jitsi, Teams, Meet, njll.",
    "FORM_BUILDER": {
      "ACCEPTED_ANSWERS": "Impendulo(evumelekile)",
      "ACCEPTED_ANSWERS_DATE_DESCRIPTION": "Qinisekisa usuku olunikezwe umsebenzisi ngomhla oyireferensi.",
      "ACCEPTED_ANSWERS_OPERATOR_LABEL": "Khetha opharetha",
      "ACCEPTED_ANSWERS_QUESTION_OPTIONS_DESCRIPTION": "Khetha yonke impendulo engenzeka.",
      "ACCEPTED_ANSWERS_SUMMARY": "Izimpendulo Ezivunyelwe",
      "ACCEPTED_ANSWERS_TEXT_DESCRIPTION": "Hlukanisa impendulo ngayinye evunyelwe ngomugqa omusha.",
      "ACCEPTED_ANSWERS_TEXT_PLACEHOLDER": "Impendulo 1\nImpendulo 2\nImpendulo 3\nImpendulo 4",
      "ADD_DESCRIPTION": "Engeza incazelo",
      "ADD_QUESTION": "Engeza umbuzo",
      "ADD_SECTION": "Engeza isahluko",
      "CONFIDENTIAL": "Imfihlo",
      "CONFIDENTIAL_INFORMATION_NOTICE": "Impendulo yakho izobonakala kuphela ngabaphathi beplathifomu.",
      "CONFIDENTIAL_QUESTION": "Umbuzo oyimfihlo",
      "CONFIDENTIAL_QUESTION_DESCRIPTION": "Impendulo izobonakala kuphela kubaphathi nabaphathi abanamalungelo.",
      "DATE_OPERATOR": {
        "EQ": "ukuqala",
        "GT": "kukuhle kuno",
        "GTE": "ikhona noma ilingana ne-",
        "LT": "iphansi kuno",
        "LTE": "kuphansi noma kulingana ne-",
        "NOT_EQ": "akuyona"
      },
      "DEFAULT_FIELD_INFO": "Ngokujwayelekile",
      "DESCRIPTION_LABEL": "Incazelo",
      "DESCRIPTION_PLACEHOLDER": "Isibonelo: Lo mbuzo uzosisiza ukuba sikwazi kangcono ngawe.",
      "DROPDOWN_QUESTION": "Uhlu yokudonsela phansi",
      "DROPDOWN_QUESTION_DESCRIPTION": "Izinketho zizoboniswa ohlwini lokudonsela phansi.",
      "MAXLENGTH": "Nciphisa inani lezimpawu zokubhala",
      "MAXLENGTH_DESCRIPTION": "Ngenisa inani eliphezulu lamakharikhtha avumelekile",
      "MAXLENGTH_LABEL": "Inani Lamanani Abalingiswa",
      "MAXLENGTH_PLACEHOLDER": "Okungenamkhawulo",
      "MAXLENGTH_SUMMARY": "Abalinganiselwa abakhulu.",
      "OPTIONS": {
        "ADD_OPTION": "Engeza inketho",
        "ADD_OTHER": "Engeza « Okunye »",
        "OR": "noma",
        "OTHER": "Okunye"
      },
      "OPTION_LABEL": "Inketho {index}",
      "PLACEHOLDER": "Impendulo yakho",
      "QUESTION_LINKS": {
        "DESCRIPTION": "Bonisa uma impendulo ku ...",
        "OPERATOR": {
          "BLANK": "ilikhala",
          "CONTAINS": "iqukethe",
          "EQ": "iyona",
          "GT": "kudlula",
          "GTE": "kukukhulu noma kulingana ne-",
          "LT": "kunciphansi ku",
          "LTE": "kuncane noma kulingana ne",
          "NOT_CONTAINS": "ayiqukethe",
          "NOT_EQ": "akuyona",
          "PRESENT": "akukho lutho"
        },
        "OPERATOR_LABEL": "Umsebenzi",
        "OPTIONS_LABEL": "Izinketho",
        "QUESTION_LABEL": "Umbuzo",
        "TITLE": "Ukuboniswa kombuzo"
      },
      "QUESTION_LINKS_SUMMARY": "Imibandela yokubonisa",
      "REQUIRED": "Kuyadingeka",
      "REQUIRED_QUESTION": "Umbuzo oyimpoqo",
      "SUBMIT_FORM": "Thumela ifomu",
      "SURVEY_DESCRIPTION_1": "Umbuzo uhlanganisa imibuzo ofuna ukuyibeka kubasebenzisi bakho.",
      "SURVEY_DESCRIPTION_2": "Lungiselela inhlolovo ngokuhambisana nokubonisana kwakho.",
      "SURVEY_TITLE": "Inhlolovo",
      "TITLE_LABEL": "Umbuzo",
      "TITLE_PLACEHOLDER": "Isibonelo: Uneminyaka emingaki?",
      "TYPES": {
        "ATTACHMENT": "Izithombe ezinamathiselwe",
        "CHECKBOX": "Izimpendulo eziningi",
        "DATE": "Idethi",
        "LOCATION": "Indawo",
        "MONEY": "Isabelomali engenamkhawulo",
        "PHONE_NUMBER": "Inombolo yocingo",
        "PICTURE": "Isithombe esimboza incwadi",
        "RADIO": "Impendulo eyodwa",
        "SECTION": "Ingxenye",
        "TEXT": "Impendulo emfushane",
        "TEXTAREA": "Umlando",
        "TITLE": "Uhlobo lwenkundla"
      },
      "TYPE_SELECT_WARNING": {
        "DESCRIPTION_1": "Usuvele uthathe izimpendulo zalombuzo.",
        "DESCRIPTION_2": "Uma uyishintsha, izimpendulo ezihambisanayo zizokhishwa unomphela.",
        "DESCRIPTION_3": "Udinga le datha? Thumela impendulo yakho ngaphambi kokususa lo mbuzo futhi/okanye inketho.",
        "TITLE": "Uqinisekile?"
      }
    },
    "GENERAL_INFO": "Ulwazi olujwayelekile",
    "IMAGE": "Isithombe",
    "LOCALISATION_LABEL": "Indawo noma ikheli",
    "LOCALISATION_MARKER_PLACED": "Umaki ubekiwe",
    "LOCALISATION_MODAL_NEGATIVE_BUTTON": "Sula",
    "LOCALISATION_MODAL_NOTICE_TEXT": "Chofoza imephu ukuze ubeke uphawu.",
    "LOCALISATION_MODAL_POSITIVE_BUTTON": "Qinisekisa",
    "LOCALISATION_MODAL_TITLE": "Engeza indawo",
    "LOCALISATION_NO_RESULTS": "Sicela uthayiphe ukuze uthole iziphakamiso.",
    "LOCALISATION_PLACEHOLDER": "Faka indawo",
    "LOCALISATION_SEE_MAP": "Bona imephu",
    "MODERATABLE": {
      "LABEL": "Ukubhekisiswa ngaphambi kokushicilelwa",
      "TOOLTIP": "Wonke amagalelo adinga ukuvunywa umphathi ukuze ashicilelwe futhi abonakale kwabanye abasebenzisi."
    },
    "NEW": {
      "ANOMALIES": {
        "DESCRIPTION_PLACEHOLDER": "Ngicela uxoxe ngokucacile ngengozi oyibonile kanye nohlobo lwayo. Nika isimo ukuze kube lula ukuyisingatha.",
        "MODAL_DESCRIPTION": "{spaceName} uzophendula ngokushesha okukhulu.",
        "MODAL_TITLE": "Siyavuyisana, iphutha selithunyelwe!",
        "SIDEBAR_ACTION": "Thumela",
        "SIDEBAR_DESCRIPTION": "Inhlangano ikusukela futhi izophendula ngokushesha okukhulu.",
        "TITLE": "Bika iphutha",
        "TITLE_PLACEHOLDER": "Ngithanda ukubika…"
      },
      "ARTICLES": {
        "DESCRIPTION_PLACEHOLDER": "Cela usuku oluhlobene nezindaba noma ugcizelele umkhankaso othile, ukuze wazise njalo ngezinyathelo ezintsha futhi usakaze ulwazi lwezemfundo.",
        "MODAL_DESCRIPTION": "Sekuvele kubonakala kwabanye abasebenzisi bale ndawo. {isPrivateSpace, select, true {} other {Yabelana ngakho ezinkundleni zokuxhumana ukuze kube nokubonakala okwengeziwe.}}",
        "MODAL_TITLE": "Halala, indatshana ishicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Chaza ngohlamvu olulodwa udaba lwakho ukuze unganxenxa ukufunda lona.",
        "TITLE": "Dala isihloko",
        "TITLE_PLACEHOLDER": "Bhala isihloko esidonsa ukunaka kwabasebenzisi."
      },
      "COLLABORATIVE_DECISIONS": {
        "DESCRIPTION_PLACEHOLDER": "Ngicela imininingwane mayelana nesimo salolu xoxiswano. Chaza izindlela zokubamba iqhaza ukuze abasebenzisi bakwazi ukubamba iqhaza ngendlela efanele ekutholeni izixazululo.",
        "MODAL_DESCRIPTION": "Isetshenziswa manje ukubonakala kwabanye abasebenzisi. Ungalibeka ekhasini lakho eliyisiqalo ngokuliphakamisa ukuze libonakale kakhulu.",
        "MODAL_TITLE": "Halala, ukuxoxisana sekushicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Yenza abasebenzisi bafise ukubamba iqhaza ngomusho owodwa.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE": "Dala ukubonisana",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa isasasa kubasebenzisi."
      },
      "DEMANDS": {
        "DESCRIPTION_PLACEHOLDER": "Cela uhlale umongo wesaziso ngokukhomba noma iyiphi ingxenye engasiza ekutholeni ukuqonda okungcono kwesihloko sakho.",
        "MODAL_CTA": "Bheka imilayezo yami",
        "MODAL_DESCRIPTION": "Umamukeli uzothola isaziso ngokushesha okukhulu. Ungathola lo mlayezo nganoma yisiphi isikhathi kumenyu ethi “Imilayezo Yami & Iziphazamiso” ephrofayilini yakho.",
        "MODAL_TITLE": "Siyajabula, umlayezo uthunyelwe!",
        "SIDEBAR_ACTION": "Thumela",
        "SIDEBAR_DESCRIPTION": "Lo okuqukethwe kuyimfihlo. Umsebenzisi kuphela nabaphathi abangakubuka.",
        "TITLE": "Thumela umlayezo",
        "TITLE_PLACEHOLDER": "Ngithanda ukuthola ulwazi mayelana no..."
      },
      "EVENTS": {
        "CONFIGURATION": {
          "DESCRIPTION": "Le ngxenye ivumela ukuthi uchaze abasebenzisi usuku nendawo (ikheli kanye / noma isixhumanisi sokuxhumana ngevidiyo) somcimbi.",
          "TITLE": "Izindlela zokubamba iqhaza"
        },
        "DESCRIPTION_PLACEHOLDER": "Nikeza isimo somcimbi futhi wazise abasebenzisi ngezimo zokuhambela khona.",
        "MODAL_DESCRIPTION": "Manje isibonakala kwabanye abasebenzisi. Yabelana ngakho ezinkundleni zokuxhumana ukuze ukwandisa ukubonakala kwalo.",
        "MODAL_TITLE": "Halala, umcimbi usushicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Chaza ngomusho owodwa umcimbi wakho ukuze uvuse isifiso sokuwufunda.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esizodonsa ukunaka kwabasebenzisi."
      },
      "FOLDERS": {
        "DESCRIPTION_PLACEHOLDER": "Sicela unikeze imininingwane mayelana nesimo salolu daba. Chaza izindlela zokubamba iqhaza ukuze abasebenzisi bakwazi ukubamba iqhaza ngendlela efanele ekufuneni izixazululo.",
        "MODAL_DESCRIPTION": "Manje usubonwa abanye abasebenzisi. Liphanyeke ekhasini lakho lasekhaya ukuze libonakale kakhulu.",
        "MODAL_TITLE": "Siyavuyisana, ifayela selishicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Engeza umusho okhuthazayo mayelana nedokhumenti yakho.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esiheha abasebenzisi."
      },
      "IDEAS": {
        "DESCRIPTION_PLACEHOLDER": "Chaza ngomnikelo wakho nokusebenza kwawo.",
        "MODAL_CTA": "Bona iminikelo yami",
        "MODAL_DESCRIPTION": "Thola yonke iminikelo yakho ephrofayilini yakho.",
        "MODAL_DESCRIPTION_GUEST": "Ukulandela intuthuko yayo futhi uthole izibuyekezo, dala i-akhawunti. Ngaphandle kokubhalisa, ngeke usakwazi ukubona umthelela wayo noma waziswe ngama-voti namazwana.",
        "MODAL_TITLE": "Ngiyabonga ngokuhlanganyela kwakho",
        "REDIRECT": "Uxolo, lelinki alibonakali lisebenza. Thola ukubonisana ohlwini ukuze ukwazi ukufaka isandla.",
        "TITLE": "Gcwalisa ifomu",
        "TITLE_PLACEHOLDER": "Singakwenza…",
        "WITHOUT_MODERATION": {
          "SIDEBAR_ACTION": "Shicilela",
          "SIDEBAR_DESCRIPTION": "Lapho ishicilelwa, abanye abasebenzisi bazokwazi ukucebisa okunye ukuze kwandiswe umnikelo wakho."
        },
        "WITH_MODERATION": {
          "SIDEBAR_ACTION": "Thumela",
          "SIDEBAR_DESCRIPTION": "Umnikelo uzoshicilelwa uma usuvunyiwe izinsiza."
        }
      },
      "IDEAS_REQUESTS": {
        "DESCRIPTION_PLACEHOLDER": "Hlinzeka imininingwane mayelana nesimo salokhu kubizelwa ekufakeni izindlunkulu. Chaza izindlela zokubamba iqhaza ukuze abasebenzisi bakwazi ukubamba iqhaza ngendlela efanele ekufuneni izixazululo.",
        "MODAL_DESCRIPTION": "Manje isibonwa abanye abasebenzisi. Sikhonze ekhasini lakho lokuqala ngokusibeka esigabeni esifakiwe ukuze sibonakale kakhulu.",
        "MODAL_TITLE": "Siyakuhalalisela, isimemo sokufaka izindatshana sishicileliwe!",
        "PROBLEMATIC_PLACEHOLDER": "Khuthaza abasebenzisi ukuba babambe iqhaza ngomusho owodwa.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esivusa intshisekelo kubasebenzisi."
      },
      "PARTICIPATORY_BUDGETS": {
        "DESCRIPTION_PLACEHOLDER": "Nikeza imininingwane mayelana nesimo salo mali eyabiwe yokubamba iqhaza. Chaza izindlela zokubamba iqhaza ukuze abasebenzisi bakwazi ukungenelela ngendlela efanele ekufuneni izixazululo.",
        "MODAL_DESCRIPTION": "Sekuvele kubonakala kwabanye abasebenzisi. Qiniseka ukuthi usubeke ekhasini lakho lokuqala ukuze ubonakale nakakhulu.",
        "MODAL_TITLE": "Siyakuhalalisela, isabelomali sokubamba iqhaza sesishicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Donsa abasebenzisi ukuthi babambe iqhaza ngomusho owodwa.",
        "SIDEBAR_ACTION": "Shicilela",
        "TITLE_PLACEHOLDER": "Bhala isihloko esidonsa ukunaka kwabasebenzisi."
      },
      "STUDIES": {
        "DESCRIPTION": "Uxhaso luhambelana nefomu elenziwe ngaphandle kwepulatifomu kwi-Typeform, i-Google Form, i-Survey Monkey, i-Tally noma iyiphi enye ipulatifomu evumela ukudala amafomu.",
        "DESCRIPTION_PLACEHOLDER": "Nika imininingwane mayelana nesimo salo mhlangano kanye nezindlela zokubamba iqhaza.",
        "FORM_DESCRIPTION": "Engeza izixhumanisi zocwaningo lwakho ukuze ulwabelane ngalo kuplathifomu yakho.",
        "MODAL_DESCRIPTION": "Sekuyabonakala kwabanye abasebenzisi. Yabelana ngayo ezinkundleni zokuxhumana ukuze inikezwe ukubonakala okwengeziwe.",
        "MODAL_TITLE": "Siyavuyisana, ucwaningo selushicilelwe!",
        "PROBLEMATIC_PLACEHOLDER": "Yenza abasebenzisi bafune ukubamba iqhaza ngomusho owodwa.",
        "SIDEBAR_ACTION": "Shicilela",
        "STUDY_ID_PLACEHOLDER": "Ngokwesibonelo: https://fluicity.typeform.com/to/A1b2C3d4",
        "STUDY_RESULT_PLACEHOLDER": "Isibonelo: https://fluicity.typeform.com/report/A1b2C3d4/E5f6G7h8",
        "STUDY_RESULT_TITLE": "Isixhumanisi somphumela",
        "STUDY_TITLE": "Isixhumanisi senhlolovo",
        "TITLE_PLACEHOLDER": "Qamba isihloko esidonsela abasebenzisi."
      },
      "TITLE": {
        "ANOMALY": "Dala i-anomaly",
        "COMMUNICATION": "Dala izindaba ezintsha",
        "CONSULTATION": "Dala ukubonisana",
        "DEMAND": "Dala umlayezo",
        "FOLDER": "Dala ifolda.",
        "IDEA": "Dala umnikelo"
      }
    },
    "POST_PUBLISHED": "Lo okuqukethwe sekushicilelwe manje.",
    "POST_PUBLISHED_AT": "Kushicilelwe ngo-{date} ngo-{time}",
    "POST_SAVED": "Izinguquko zigcinwe.",
    "POST_SCHEDULED": "Lo okuqukethwe kuhlelwe ngo-{date} ngo-{time}",
    "PROBLEMATIC": "Ukubamba",
    "PUBLICATION_CANCELLED": "Ukushicilelwa kumisiwe ngempumelelo.",
    "SIMILAR_PROPOSALS": "Abanye abasebenzisi kubonakala sengathi babelane ngezimnikelo ezifana nalezi:",
    "START_AT": "Usuku nesikhathi sokuqala",
    "STEPS": {
      "CONFIGURATION": "Ukulungiselelwa kwesigaba",
      "DESCRIPTION": "Le ngxenye ivumela ukuxhumana nabasebenzisi ngezinsuku ezibalulekile zokubonisana.",
      "DESCRIPTION_TABS": "Izinkinobho zencazelo yezilimi eziningi zesigaba",
      "END_AT_HELPER_TEXT": "Okhethiweyo ezigabeni eziqhubekayo",
      "IMPLEMENTATION": {
        "ADMIN_ONLY_PLACEHOLDER": "Cela uma kuhlanganisa \"Isixhumanisi semiphumela\" bese uhlole izilungiselelo ukuvula inketho.",
        "ADMIN_ONLY_TEXT": "Veza imiphumela yokubonisana",
        "SURVEYS": {
          "ADMIN_ONLY_PLACEHOLDER": "Umbiko ophelele wethula yonke imiphumela yocwaningo, umbuzo ngombuzo. Lokhu kuyisici esibalulekile sokungafihli lutho kubasebenzisi.",
          "ADMIN_ONLY_TEXT": "Bonisa imiphumela yokubonisana"
        }
      },
      "PLACEHOLDER": "Chaza ukuthi lesi sigaba senziwa kanjani.",
      "SUBMISSION": {
        "ADMIN_ONLY_PLACEHOLDER": "Wonke umsebenzisi angashicilela okufakwayo ekubonisaneni. Uma inketho ivaliwe, abaphathi kuphela abazokwazi ukudala okufakwayo okusha.",
        "ADMIN_ONLY_TEXT": "Idiphozithi evulekile kubasebenzisi"
      },
      "TITLE": "Ukucushwa kokuphuma"
    },
    "TITLE": "Isihloko",
    "UNDERSTOOD": "Kuqondiwe!",
    "VIDEO": "Ividiyo",
    "VIDEO_HELPER": "Ungabelana kuphela ngevidiyo ye-Youtube noma ye-Vimeo.",
    "VIDEO_LABEL": "Isixhumanisi sevidiyo",
    "VIDEO_PLACEHOLDER": "Isibonelo: http://www.youtube.com/watch?=id noma http://vimeo.com/id",
    "VOTING_OPTIONS": {
      "BUDGET_RULE": {
        "LABEL": "Ukunciphisa amavoti (Yebo) esabelweni se-{count} esibekwe ngaphambilini",
        "TITLE": "Umkhawulo wezimali"
      },
      "MIN_MAX": {
        "MAX_LABEL": "Inani eliphezulu lamavoti",
        "MIN_LABEL": "Inani elincane kakhulu lamavoti",
        "TITLE": "Inani lezinsiza ezinikeziwe"
      },
      "TYPE": {
        "BUDGET": {
          "DESCRIPTION": "Abasebenzisi bazokwazi ukuxhasa iminikelo kuze kuphele isamba esiphelele. Iminikelo kufanele ibekelwe isabelomali.",
          "NAME": "Ngoku ku-eyebheni"
        },
        "DOUBLE": {
          "DESCRIPTION": "Abasebenzisi bazokwazi ukusekela iminikelo ngendlela enhle noma engemihle. Kuvame ukusetshenziswa uma kubizwa iminikelo noma izimpendulo.",
          "NAME": "Ngokwesekwa noma Ngokuphikiswa"
        },
        "SINGLE": {
          "DESCRIPTION": "Abasebenzisi bazokwazi ukuxhasa iminikelo ngendlela enhle kuphela. Leli module livame ukusetshenziswa uma ukubonisana kwakho kuhloswe ukuhlela isigaba sokuvota.",
          "NAME": "Ngokwe-"
        },
        "SUBTITLE_1": "Izindlela zokuvota zivumela abasebenzisi ukuthi basekele iminikelo eyenziwe ekubonisaneni kwakho.",
        "SUBTITLE_2": "Lungiselela izindlela ngokuya ngephrojekthi yakho.",
        "TITLE": "Izindlela zokuvota"
      },
      "UNLIMITED": "Okungapheli"
    }
  },
  "POST_STEPS_TYPES": {
    "DEFAULT": {
      "ANALYSIS": "Ukuhlaziya",
      "CONTRIBUTION": "Umnikelo",
      "IMPLEMENTATION": "Imiphumela",
      "SUBMISSION": "Idiphozi",
      "VOTE": "Vota"
    },
    "STUDY": {
      "IMPLEMENTATION": "Imiphumela",
      "SUBMISSION": "Impendulo"
    }
  },
  "PREVIOUS": "Okuqukethwe Kwangaphambilini",
  "PROFILE": {
    "ADDRESS": "Umphakathi",
    "BIRTHDATE": "Usuku lokuzalwa",
    "CROSS_SPACES_WARNING": "Ulwazi olungezansi luyehlukene mayelana nazo zonke izikhala ohlanganise nazo.",
    "FIRST_NAME": "Igama lokuqala",
    "LAST_NAME": "Igama",
    "NAME_IS_PRIVATE": "Abanye abasebenzisi bazokubona njengo: {displayName}",
    "NATIONAL_ID": "Inombolo yokubhaliswa kazwelonke",
    "PRIVATE_INFORMATION_NOTICE": "Lezi zinkcukacha zizoba zisetyenziswa kuphela ngeenjongo zokubala izibalo ezinxulumene nokuthatha inxaxheba.",
    "PROFILE_UPDATED": "Iphrofayela ibuyekeziwe.",
    "SEX": "Ubulili",
    "SEX_FEMALE": "Owesifazane",
    "SEX_HELPER": "Njengoba kubonisiwe ku-ID yakho kazwelonke. Lolu lwazi, uma seluhlanganisiwe, luqhathaniswa nezibalo ezinikezwe izikhungo zikazwelonke noma yinhlangano uqobo lwayo.",
    "SEX_MALE": "Indoda",
    "SEX_UNSPECIFIED": "Akukashiwongo.",
    "SOCIOPROFESSIONAL_CATEGORY": "Ikhathalogi yezenhlalakahle nezomsebenzi",
    "TITLE": "I-akhawunti yami"
  },
  "PUBLISHING_POST_DIALOG": {
    "NO_QUESTIONS_WARNING": "Ngaphambi kokuba ukwazi ukushicilela lokhu okuqukethwe, kufanele {link} kwifomu.",
    "NO_QUESTIONS_WARNING_LINK_TEXT": "engeza imibuzo",
    "PARENT_WARNING": "Ngaphambi kokuthi ukwazi ukuveza loku okuqukethwe, kudingeka ukuthi upapashe {link}.",
    "PUBLISH": {
      "BUTTON": "Shicilela manje",
      "CONTENT": "Ngabe ngabe ufuna ngempela ukushicilela?",
      "NO": "Cha",
      "TOAST": "Lo okuqukethwe kushicilelwe.",
      "YES": "Yebo, shicilela"
    },
    "SCHEDULE": {
      "BUTTON": "Hlela ukushicilelwa",
      "CONTENT": "Ufuna ngempela ukuhlela?",
      "NO": "Cha",
      "TOAST": "Lo mkhombandlela uhleliwe.",
      "YES": "Yebo, hlela"
    },
    "UNPUBLISH": {
      "BUTTON": "Susa ekushicilelweni",
      "CHILDREN_WARNING": "Ngokuthi ungashicileli lokhu okuqukethwe, konke okuqukethwe nakho ngeke kushicilelwe ({childrenCount}).",
      "CONTENT": "Ufuna ngempela ukuhoxisa?",
      "NO": "Cha",
      "TOAST": "Lo okuqukethwe kuhanjisiwe.",
      "YES": "Yebo, susa ekushicilelweni"
    },
    "UNSCHEDULE": {
      "BUTTON": "Khansela ukuhlelwa kwamashejuli",
      "CONTENT": "Ingabe ufuna ngempela ukukhansela ukuhlela?",
      "NO": "Non",
      "TOAST": "Ukucwangciswa kwalokhu okuqukethwe kukhanseliwe.",
      "YES": "Yebo, khansela ukuhlela"
    }
  },
  "QUESTIONS": {
    "RESULTS": {
      "ANSWERS_COUNT": "{count, plural, =0 {Azikho izimpendulo} one {{count} impendulo} other {{count} izimpendulo}}"
    }
  },
  "SEARCH": {
    "BUTTON": "Ukucinga",
    "CATEGORIES_PLACEHOLDER": "Hlunga ngokwe ndaba",
    "EMPTY_SEARCH": {
      "NEW_SEARCH": "Qala ngokuthayipha amagama angukhiye kubha yokusesha.",
      "NO_RESULTS": "Qinisekisa ukuthi ubhale konke kahle. Ungazama futhi ukufinyeza noma ukuguqula umbuzo wakho wosesho."
    },
    "INPUT_PLACEHOLDER": "Ukusesha",
    "RESULTS_COUNT": "{count, plural, =0 {Akukho mphumela} one {{count} umphumela} other {{count} imiphumela}}",
    "TYPES_PLACEHOLDER": "Hlunga ngohlobo lokuqukethwe"
  },
  "SECURED_STRATEGIES": {
    "BACK_TO_POST": "Buyela ekubonisaneni",
    "BIRTHDATE": {
      "TITLE": "Usuku lokuzalwa"
    },
    "CSAM": {
      "TITLE": "Ukungena ngemvume nge-CSAM"
    },
    "CTA": "Bamba iqhaza",
    "DESCRIPTION": "<b>Lo mbuzo uphephile.</b> Ukuze uwufinyelele, kufanele uqinisekise idatha ebhalwe ngezansi bese ufaka leyo engekho.<conditional> Noma yinini, ungasebenzisa amalungelo akho okufinyelela, okulungisa nokususa le datha ngokuxhumana no dpo@flui.city.</conditional>",
    "DIMENSIONS": {
      "ERROR": "Ngokudabukisa, imininingwane oyinikezile ayikuvumeli ukuthi ubambe iqhaza ekubonisaneni. Lungisa idatha yakho noma ubuyele ekubonisaneni.",
      "TITLE": "Ubukhulu"
    },
    "INLINE_DESCRIPTION": "<b>Lo mkhankaso uphephile.</b> Ukuze ufike kuwo, kufanele ufake idatha edingekayo. Noma yinini, ungasebenzisa amalungelo akho okufinyelela, ukulungisa kanye nokususa le datha ngasekhaya lephrofayela yakho uma unakho-akhawunti noma nge-imeyili ku-dpo@flui.city.",
    "NATIONAL_ID": {
      "ERROR": "Kufanele ufake inombolo yokubhalisa evumelekile equkethe izinombolo ezingu-11.",
      "TITLE": "Inombolo yokubhaliswa kazwelonke"
    },
    "PENDING_VERIFICATION_TOOLTIP": "Ukubamba kwakho iqhaza kuzobhekwa kuphela <b>ngemva kokuhlolwa kwemibhalo yakho</b>.",
    "PREVENT_GO_IDENTITY": {
      "BACK": "Emuva (ikhadi lokuzazisa elisha kuphela)",
      "FORM": {
        "DESCRIPTION": "Sicela uhlinzeke uhlangothi olungaphambili nolungemuva lwekhadi lakho likamazisi (ifomethi JPEG, JPG, PNG, HEIC, WEBP noma PDF, usayizi omkhulu onconyiwe 2MB).<br></br>Okwamukelekile kuphela:<ul><li>Ikhadi likamazisi likazwelonke</li><li>Uhlelo lwepasipoti yaseFrance</li><li>Ilayisensi yokushayela (ifomethi entsha yekhadi lesikweletu)</li></ul>",
        "GENERIC_ERROR": "Kwenzeke iphutha ngesikhathi ulayisha amadokhumenti akho. Sicela uhlole isimo sokuxhumana kwakho noma uzame futhi kamuva. Ungazama futhi ngokunciphisa usayizi wedokhumenti (usayizi omkhulu ohlongozwayo ngu-2MB).",
        "SUCCESS_TOAST": "Ubunikazi bakho buqinisekisiwe ngempumelelo."
      },
      "FRONT": "Ngaphambili",
      "NO": "Cha",
      "TITLE": "Isazisi",
      "YES": "Yebo"
    },
    "PROOF_OF_RESIDENCY": {
      "ACCEPTED_DOCUMENTS": "Kuvunyelwe kuphela: <ul><li>Inkontileka kagesi, yegesi noma yamanzi yakamuva</li><li>Inkontileka yocingo oluqinile noma oluphathwayo</li><li>Iphepha lomsebenzi</li><li>Isitifiketi somshwalense wendawo yokuhlala (umlilo, izingozi zokuhlala noma umthwalo wemfanelo womphakathi)</li><li>Ikhadi lokuvota</li><li>Isaziso sentela</li></ul>",
      "BUTTON_DISABLED_TOOLTIP": "Kufanele uqale uqinisekise isazisi sakho ukuze uthumele ubufakazi bakho bokuhlala.",
      "DESCRIPTION": "Sicela unikeze ubufakazi bekheli (kuma-JPEG, JPG, PNG, HEIC, WEBP noma amafomethi e-PDF, usayizi omkhulu onconyiwe ngu-2MB).",
      "DOCUMENT_CONFIRMATION": "Ngemuva kokuhlolwa ngamaqembu ethu, kuzothunyelwa i-imeyili ukuze kuqinisekiswe ukubamba kwakho iqhaza.",
      "TITLE": "Ubufakazi bendawo yokuhlala"
    },
    "QUESTIONS": {
      "INCORRECT_VALUE": "Le ntengo ayilungile."
    },
    "SIGNUP_INVITATION": "Uma ufuna <b>ukuthola i-imeyili yokuqinisekisa</b> ngokubamba kwakho iqhaza bese ugcina imibhalo yakho, sicela udale i-akhawunti.",
    "SUCCESS": "Ungakwazi manje ukubamba iqhaza ekubonisaneni.",
    "TOOLTIP": "Lokhu kubonisana kuphephile futhi kudinga ulwazi oluthile ukuze ubambe iqhaza.",
    "VALIDATED_INLINE_DESCRIPTION": "Siqinisekisile ubuqotho bakho njengo <b>{fullName}</b>.",
    "VERIFIED_EMAIL": {
      "TITLE": "Ukuqinisekiswa kwe-akhawunti"
    }
  },
  "SECURITY": {
    "DISPLAY_SECURED_STRATEGY_QUESTIONS": "Bonisa imibuzo yezokuphepha",
    "FORM_BUILDER": {
      "DESCRIPTION": "Imibuzo yezokuphepha iyizindlela zokulawula ukufinyelela.<br></br> Zivumela ukuqinisekisa ukuthi ababambiqhaza bayahlangabezana nezimo ezithile ngaphambi kokuhlanganyela, ukuvota, ukuphawula noma ukuphendula ucwaningo (isb: ikhodi yokufinyelela, i-ID kazwelonke, umhlali wendawo ethile, njll.).",
      "TITLE": "Imibuzo yokuqinisekisa ukuphepha"
    },
    "OPTION_1": {
      "DESCRIPTION": "Akukho ukubhaliswa okudingekayo ukuze ubambe iqhaza",
      "TITLE": "Wonke umuntu"
    },
    "OPTION_2": {
      "DESCRIPTION": "Abasebenzisi kumele babhalise ukuze babambe iqhaza.",
      "TITLE": "Ababhalisile"
    },
    "OPTION_3": {
      "DESCRIPTION": "Abasebenzisi kufanele baqinisekise i-akhawunti yabo ukuze babambe iqhaza.",
      "TITLE": "Abasebenzisi abaqinisekisiwe"
    },
    "OPTION_4": {
      "DESCRIPTION": "Idipho livaliwe kubasebenzisi",
      "TITLE": "Abaphathi"
    },
    "WHO_CAN_COMMENT": "Ubani ongaphawula?",
    "WHO_CAN_RESPOND_SURVEY": "Ubani ongaphendula ocwaningweni?",
    "WHO_CAN_SUBMIT_CONTRIBUTION": "Ubani ongafaka umnikelo?",
    "WHO_CAN_VOTE": "Ubani ongavota?"
  },
  "SETTINGS": {
    "ACCOUNT": {
      "CONNECTION_SETTINGS": "Izilungiselelo Zokungena Kwenethiwekhi",
      "DATA_SHARED_WITH_SPACE": "Idatha yami",
      "LANGUAGE": "Ulimi",
      "PASSWORD": "Iphasiwedi (ubuncane izinhlamvu eziyi-12)",
      "VERIFIED": "Kuqinisekisiwe",
      "VERIFIED_EMAIL": "I-imeyili Iqinisekisiwe"
    },
    "COOKIES": {
      "DESCRIPTION": "Amakhukhi “okusebenza” alandelayo avumela ukunika amandla izici ezithile nezikhethwayo ku-Fluicity Engage ukuze kuthuthukiswe isipiliyoni sakho somsebenzisi.",
      "FACEBOOK": {
        "DESCRIPTION": "Ikunika ukufinyelela endaweni yakho yokubamba iqhaza usebenzisa i-akhawunti yakho ye-Facebook.",
        "TITLE": "Facebook Xhuma"
      },
      "GOOGLE": {
        "DESCRIPTION": "Kukuvumela ukuthi uxhumeke endaweni yakho yokubamba iqhaza usebenzisa i-akhawunti yakho ye-Google.",
        "TITLE": "Ukungena ngemvume kwe-Google"
      },
      "TITLE": "Izintandokazi zami mayelana nama-cookies",
      "VIMEO": {
        "DESCRIPTION": "Kuvumela ukubuka amavidiyo abanjwe ku-Vimeo ngqo kusukela endaweni yakho yokubamba iqhaza.",
        "TITLE": "Vimeo"
      },
      "YOUTUBE": {
        "DESCRIPTION": "Kuvumela ukubuka amavidiyo agcinwe ku-Youtube ngqo kusuka endaweni yakho yokubamba iqhaza.",
        "TITLE": "I-YouTube"
      }
    },
    "DESTROY_ACCOUNT": {
      "CONFIRM": "Yebo, susa i-akhawunti yami",
      "CTA": "Susa i-akhawunti yami",
      "TITLE": "Uqinisekile ukuthi ufuna ukususa i-akhawunti yakho ye-Fluicity Engage?"
    },
    "EMAIL_SUBSCRIPTION": {
      "UNSUBSCRIBE": {
        "SUCCESS_DESCRIPTION": "Ukuzikhupha noma ukubhalisela kabusha izinhlobo ezithile zezaziso, ungaguqula izilungiselelo zakho ngezansi. Lezi zilungiselelo zifinyeleleka noma yinini kusukela kuzilungiselelo ze-akhawunti yakho.",
        "SUCCESS_TITLE": "Isicelo sakho sokuzikhupha siqinisekisiwe."
      }
    },
    "JOIN_SPACE": "Joyina {spaceName}",
    "LANGUAGE": {
      "LABEL": "Ulimi"
    },
    "LEAVE_SPACE": {
      "CONFIRM": "Yebo, shiya isikhala",
      "CTA": "Shiya {spaceName}",
      "DESCRIPTION": "Uma ushiya lesi sikhala, ngeke usathola izaziso ezihlobene nokubonisana noma izindaba futhi ngeke usakwazi ukwenza iminikelo emisha, ukuphawula, ukuvota, njll.",
      "TITLE": "Uqinisekile ukuthi ufuna ukuphuma ku-{spaceName}?"
    },
    "NO_SPACES": "Awazi ndawo.",
    "PASSWORD": {
      "CONFIRMATION": "Ukuqinisekisa iphasiwedi",
      "CREATE": "Dala",
      "CREATE_INPUT": "Dala iphasiwedi entsha",
      "CREATE_MESSAGE": "Awukakabi iphasiwedi okwamanje.",
      "CURRENT": "Iphasiwedi Yamanje",
      "DIALOG": {
        "CREATE_TITLE": "Dala iphasiwedi entsha",
        "SUBTITLE_2": "Ngicela ufake iphasiwedi yakho yamanje nephasiwedi entsha:",
        "TITLE": "Shintsha iphasiwedi yami",
        "VALIDATE": "Qinisekisa"
      },
      "ERROR_LOGIN": "Iphutha lokuxhuma.",
      "FORGOT_PASSWORD": "Ukhohlwe iphasiwedi?",
      "NEW": "Iphasiwedi Entsha",
      "PLACEHOLDER": "Iphasiwedi",
      "SHORT_PASSWORD": "Ubude bephasiwedi abunakuba ngaphansi kuka-{length} izinhlamvu",
      "SUCCESS": "Iphasiwedi entsha isilondoloziwe.",
      "UPDATE": "Guqula",
      "WRONG_PASSWORD": "Iphasiwedi kumele ibe okungenani izinhlamvu eziyi-8."
    },
    "PERSONAL_DATA": {
      "REQUEST_PERSONAL_DATA": {
        "BUTTON": "Cela une demande pour la portabilité de mes données personnelles.",
        "EMAIL_BODY": "Sawubona,\n\nNgokuhambisana neNqubomgomo Yobumfihlo Yedatha yesixazululo se-Fluicity Engage, ngifisa ukuthola okukhishwayo kwazo zonke izinkomba zami zomuntu siqu ezigcinwe endaweni yesikhulumi.\n\nI-imeyili yami yokungena endaweni yesikhulumi: {userEmail}\n\nNgiyabonga kusengaphambili,\n\n{userName}",
        "EMAIL_SUBJECT": "Isicelo sokuthuthwa kwemininingwane yami"
      },
      "TITLE": "Ubumfihlo Nedatha Yomuntu Siqu"
    },
    "REQUIRED_DIMENSION_INFO": "Eminye imininingwane iyadingeka ukuze ubambe iqhaza kulesi sikhala. Ukuze usebenzise amalungelo akho okuhoxisa, vele ushiye isikhala.",
    "SPACE_SELECTION": "Ukukhetha isikhala",
    "TABS": {
      "INFO": "Ulwazi lwami",
      "MY_SPACE": "Indawo yami",
      "NOTIFICATIONS": "Izaziso zami",
      "SETTINGS": "Izilungiselelo zami"
    }
  },
  "SIGN_IN": "Joyina",
  "SIGN_OUT": "Phuma Ngemvume",
  "SIGN_UP": {
    "EMAIL": "I-imeyili",
    "LOCATION_LABEL": "Idolobha lokuhlala",
    "LOCATION_PLACEHOLDER": "Isibonelo: Paris",
    "PRIVACY": "Inqubomgomo Yobumfihlo",
    "TERMS": "Imigomo Yokusebenzisa"
  },
  "SORT": {
    "COMMENTED": "Ezibhekwe kakhulu kakhudlwana",
    "LEAST_EXPENSIVE": "Ezishibhile kakhulu",
    "POPULAR": "Kudumile",
    "RANDOM": "Ngokungahleliwe",
    "RECENT": "Okudingekayo kwakamuva",
    "UPVOTED": "Ezithandwa kakhulu"
  },
  "SPACE": {
    "ABOUT": {
      "STATS": {
        "CONSULTATIONS_COUNT": "{count, plural, =0 {ukubonisana kuqaliswe} one {ukubonisana kuqaliswe} other {ukubonisana kuqaliswe}}",
        "IDEAS_DONE_COUNT": "{count, plural, =0 {umnikelo oqediwe} one {umnikelo oqediwe} other {iminikelo eqediwe}}",
        "PARTICIPATIONS_COUNT": "{count, plural, =0 {ukubamba iqhaza} one {ukubamba iqhaza} other {ukubamba iqhaza}}",
        "SUBSCRIBED_CITIZENS": "{count, plural, =0 {ababhalisile} one {ubhalisile} other {ababhalisile}}"
      },
      "TITLE": "Jikelele"
    },
    "CONSULTATIONS": {
      "EMPTY_STATE": "Uzothola lapha amafayela, izimemo zokunikezela, izabelomali zokubamba iqhaza nezibalo ezishicilelwe yinhlangano.",
      "TITLE": "{count, plural, =0 {Azikho izeluleko} one {{count} izeluleko} other {{count} izeluleko}}"
    },
    "CONTRIBUTIONS": {
      "MESSAGING": {
        "EMPTY_STATE": "Uzothola lapha imilayezo yakho kanye nezinkinga.",
        "TITLE": "Imilayezo yami & iziphazamisi"
      },
      "PROPOSALS": {
        "EMPTY_STATE": "Uzothola lapha iminikelo yakho.",
        "TITLE": "Iminikelo yami"
      }
    },
    "FORM": {
      "ADDRESS_LABEL": "Ikheli",
      "ADDRESS_PLACEHOLDER": "Sesha ikheli",
      "ADMINISTRATORS": "Abaphathi",
      "BRAND_LOGO_LABEL": "Ilayisense lakho lesikhala",
      "BRAND_LOGO_TOOLTIP": "Ilogo lesikhala lizovezwa phezulu kwesokunxele ekhasini kubha yokuzulazula, nasema-imeyili.",
      "COLOR_LABEL": "Umbala",
      "COLOR_PLACEHOLDER": "Umbala",
      "DECISION_MAKER_FIRST_NAME_LABEL": "Igama lomxhasi",
      "DECISION_MAKER_FIRST_NAME_PLACEHOLDER": "Faka igama lokuqala",
      "DECISION_MAKER_LAST_NAME_LABEL": "Igama lomxhasi",
      "DECISION_MAKER_LAST_NAME_PLACEHOLDER": "Ngena igama",
      "DECISION_MAKER_PICTURE_LABEL": "Isithombe sephrofayela yesixhasimabhizinisi",
      "DECISION_MAKER_ROLE_LABEL": "Uxhaso lwezikhangiso",
      "DECISION_MAKER_ROLE_PLACEHOLDER": "Cacisa ngomsebenzi wesponsa enhlanganweni yakho",
      "DESCRIPTION_HELPER": "Ibaliza ye-meta incazelo ivumela izinjini zokusesha ukuthi zibe nombono wokuqukethwe kwamakhasi aboniswa lapho kufunwa.",
      "DESCRIPTION_LABEL": "Meta incazelo",
      "DESCRIPTION_PLACEHOLDER": "Cela un texte d'accroche omfushane futhi ongena-ukukhanga",
      "EMAIL_LABEL": "I-imeyili",
      "EMAIL_PLACEHOLDER": "email@monsite.com",
      "FACEBOOK_URL_LABEL": "Facebook",
      "FACEBOOK_URL_PLACEHOLDER": "https://www.facebook.com/ikhasi_lami",
      "FAVICON_LABEL": "I-Favicon",
      "FAVICON_TOOLTIP": "Ishicilelo se-favicon siyisithonjana esivela kumathebhu wesiphequluli ukuze sihlonze kalula isayithi lakho.",
      "INSTAGRAM_URL_LABEL": "Instagram",
      "INSTAGRAM_URL_PLACEHOLDER": "https://www.instagram.com/ikhasiami",
      "LEGAL_NOTICE": {
        "COMPANY_ADDRESS": "Ikheli: 210 avenue Jean Jaurès, 69007 Lyon, France",
        "COMPANY_EMAIL": "I-imeyili: info@flui.city",
        "COMPANY_NAME": "Fluicity",
        "COMPANY_PHONE": "Ucingo: +33 4 72 51 77 55",
        "HOSTED_BY_AWS": "I apologize, I made a mistake. Let me provide the correct translation:\n\nIsiza siphethwe ngu: Amazon Web Services (AWS) eParis, eFrance",
        "HOSTING": "Ukuhlalisa",
        "HOSTING_AND_TECHNICAL_SOLUTION": "Uxhaso nesixazululo sobuchwepheshe",
        "HOST_ADDRESS": "Ikheli lomphathi: 38 avenue John F. Kennedy, L-1855 Luxembourg",
        "PLATFORM_HOSTED_BY": "Ipulatifomu iphethwe futhi iqhutshwa yi-Fluicity Engage, isixazululo esishicilelwe yinkampani i-Fluicity.",
        "THIRD_PARTY_TRUST": "Fluicity Engage isebenza njengomuntu wesithathu othembekile ekuqoqeni nasekucubunguleni idatha, ngokuhambisana ne-RGPD."
      },
      "LINKEDIN_URL_LABEL": "LinkedIn",
      "LINKEDIN_URL_PLACEHOLDER": "https://www.linkedin.com/ikhasi lami",
      "LOCALES": "Izilimi",
      "LOCALES_HELPER": "Khetha izilimi lapho abasebenzisi bezokwazi ukuzulazula kuzo kuhlelo lwakho.",
      "LOCALES_LABEL": "Izilimi Ezitholakalayo",
      "LOCALE_DEFAULT_HELPER": "Khetha ulimi oluyisisekelo lwesikhulumi sakho.",
      "LOCALE_DEFAULT_LABEL": "Ulimi olungokwezifiso",
      "LOGO_PICTURE_LABEL": "Isithombe sephrofayela sabaphathi",
      "LOGO_PICTURE_TOOLTIP": "Uma benza ukubonisana, umnikelo, umlayezo noma baphawula epulatifomu, abaphathi bazophawulwa ngalolu hlobo lwephrofayela nesithombe sephrofayela kanye negama lesikhala esikhundleni sesithombe sabo negama.",
      "NAME_HELPER": "Igama lesikhala lizoboniswa ezindaweni eziningi: egameni lamakhasi, kuma-imeyili, esikhundleni segama labaphathi, njll.",
      "NAME_LABEL": "Igama lesikhala",
      "NAME_PLACEHOLDER": "Setha igama lesikhala sakho",
      "PHONE_LABEL": "Ucingo",
      "PHONE_PLACEHOLDER": "0123456789",
      "PRIMARY_COLOR_LABEL": "Umbala oyinhloko",
      "PRIMARY_COLOR_PLACEHOLDER": "Umbala oyinhloko",
      "SECONDARY_COLOR_LABEL": "Umbala wesibili",
      "SECONDARY_COLOR_PLACEHOLDER": "Umbala wesibili",
      "SPACE_DECISION_MAKER": "Umxhasi",
      "SPACE_DECISION_MAKER_TOOLTIP": "Umxhasi uyisikhulumi senhlangano yakho esizokhuthaza, siqinisekise, sibandakanye abasebenzisi bakho.",
      "SPACE_LEGAL_NOTICE": "Imibandela Yomthetho",
      "SPACE_LEGAL_NOTICE_LABEL": "Incazelo",
      "SPACE_LEGAL_NOTICE_PLACEHOLDER": "Le nkhasi libonakala ezansi kwepulatifomu yakho, ngaphansi kwe-pied de page, ngemininingwane esihlinzekwe ngaphambili ngu-Fluicity Engage njengomhlinzeki wezinsizakalo zokusingatha kanye nomhlinzeki wezobuchwepheshe wesixazululo.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_1": "Izaziso zomthetho zivumela ukwazisa abasebenzisi ngemininingwane kamphathi wesiza, umhlinzeki wezingxenyekazi, nezimo zokuhlelwa kwepulatifomu.",
      "SPACE_LEGAL_NOTICE_TOOLTIP_2": "Ziyadingeka kuzo zonke iziza ezisemthethweni noma zomphakathi, futhi zithuthukisa ukucacisa kwezinqubomgomo zakho.",
      "SPACE_PRIVACY_POLICY": "Inqubomgomo Yobumfihlo",
      "SPACE_PRIVACY_POLICY_LABEL": "Incazelo",
      "SPACE_PRIVACY_POLICY_PLACEHOLDER": "Le nkhasi ubonakala phansi kweplathifomu yakho, ngaphansi kwephansi, ngemininingwane ye-Fluicity Engage.",
      "SPACE_PRIVACY_POLICY_TOOLTIP_1": "Inqubomgomo yobumfihlo ivumela ukwazisa abahlanganyeli mayelana nokucutshungulwa kwemininingwane yabo siqu. Ungangeza lapha imininingwane ethile enhlangano yakho (isb.: isikhathi esithile sokugcinwa, othintwayo we-DPO, ukusetshenziswa kwangaphakathi kwedatha,…).",
      "SPACE_PRIVACY_POLICY_TOOLTIP_2": "Lo mbhalo uphelelisa i-<link>nqubomgomo yobumfihlo ye-Fluicity Engage</link>, obhekelele ubuchwepheshe beplathifomu, futhi oqinisekisa ukuhambisana ne-RGPD. Ukwengeza umbhalo wakho kuyazikhethela kuye ngokuthi usebenzisa kanjani ipulatifomu.",
      "SPACE_TERMS_OF_USE": "Imigomo Yokusebenzisa",
      "SPACE_TERMS_OF_USE_LABEL": "Incazelo",
      "SPACE_TERMS_OF_USE_PLACEHOLDER": "Faka lapha okuqukethwe kwemibandela yakho yokusebenzisa eyenziwe ngendlela oyifisayo.",
      "SPACE_TERMS_OF_USE_TOOLTIP_1": "Imigomo yokusebenzisa ichaza imithetho yokusebenzisa kahle indawo yakho, amalungelo nezibopho zabasebenzisi, kanye nezithembiso zakho njengomhleli wenqubo. (isib: imithetho yokulawula, amalungelo okubamba iqhaza, njll).",
      "SPACE_TERMS_OF_USE_TOOLTIP_2": "Lo mbhalo uqedela <link>CGU d’Fluicity Engage</link>, njengesithenjwa esinethembekile futhi umshicileli wesikhulumi. Ukwengeza umbhalo wakho sihlala kuyinketho ngokuya ngokusetshenziswa kwakho kwesikhulumi.",
      "TOPICS": "Izindikimba",
      "TOPICS_DESCRIPTION": "Izindikimba zenza kube lula ukuhlela okuqukethwe kwakho ukuze usizo abasebenzisi bathole okuqukethwe ngokwezintshisekelo zabo.",
      "TWITTER_URL_LABEL": "Twitter",
      "TWITTER_URL_PLACEHOLDER": "https://twitter.com/ikhasi_lami",
      "UPDATED_SUCCESSFULLY": "Isikhala sakho sibuyekeziwe ngempumelelo.",
      "USERS_NOTIFICATIONS_SETTINGS": {
        "EVENTABLE": {
          "LABEL": "Thumela isaziso ngokuzenzakalela uma kuqalwa ukubonisana futhi kuzo zonke izigaba zokubamba iqhaza."
        },
        "TITLE": "Izaziso",
        "WEEKLY": {
          "LABEL": "Thumela isifinyezo sezindaba zeviki kubabhalisile (izihloko ezintsha, imicimbi emisha nezikhumbuzo zokubamba iqhaza engxoxweni)."
        }
      },
      "WEBSITE_URL_LABEL": "Iwebhusayithi",
      "WEBSITE_URL_PLACEHOLDER": "https://www.monsite.com",
      "YOUR_SPACE": "Isikhala sakho"
    },
    "HOME": {
      "AFFILIATES": {
        "AFFILIATED": "Izikhala ezihlobene",
        "SEE_MORE": "Buka okuningi ({count})"
      },
      "FOOTER": {
        "TITLE": "Ake sihlale sithintane!"
      },
      "SEE": "Buka",
      "SPACE_INFO": {
        "CITIZENS_COUNT": "{count, plural, =0 {Akekho obhalisile} one {{count} obhalisile} other {{count} abhalisile}}",
        "IDEAS_COUNT": "{count, plural, =0 {Azikho izibambeli} one {{count} isibambeli} other {{count} izibambeli}}"
      },
      "SPONSOR": "Le lesi sikhala sihlotshiswe no-"
    },
    "NEWS": {
      "EMPTY_STATE": "Nansi izindatshana nemicimbi eshicilelwe yinhlangano.",
      "TITLE": "{count, plural, =0 {Azikho izindaba} one {{count} izindaba} other {{count} izindaba}}"
    },
    "PRIVACY_POLICY": {
      "ACCESS_FLUICITY_PRIVACY": "Cela ku Fluicity Engage inqubomgomo yobumfihlo"
    },
    "SETTINGS": {
      "ACCESS": {
        "TAB_DATA_COLLECTION": "Ifomu yokubhalisa",
        "TAB_INVITATIONS": "Izimemo"
      },
      "COMMUNICATION": {
        "TAB_NOTIFICATIONS": "Izaziso"
      },
      "GENERAL": {
        "TAB_APPEARANCE": "Ukubukeka",
        "TAB_LANGUAGES": "Izilimi",
        "TAB_TOPICS": "Izihloko"
      },
      "LEGAL": {
        "TAB_LEGAL_NOTICE": "Izaziso Esemthethweni",
        "TAB_PRIVACY_POLICY": "Inqubomgomo Yobumfihlo",
        "TAB_TERMS_OF_USE": "Imigomo Yokusebenzisa"
      },
      "PAGES": {
        "TAB_ABOUT": "Mayelana",
        "TAB_FOOTER": "Unyaweni lwesikhasi",
        "TAB_HOME": "Ikhaya",
        "TAB_NAVIGATION": "Ibha ye-navigeshini"
      }
    },
    "TERMS_OF_USE": {
      "ACCESS_FLUICITY_TERMS": "Bheka imigomo yokusebenzisa ye-Fluicity Engage"
    }
  },
  "SPACE_DATA_COLLECTION": {
    "GENERAL_INFO": "Ulwazi olujwayelekile",
    "PROF_CATEGORY_ID": {
      "LABEL": "Isigaba sobungcweti-nhlalo"
    },
    "SECTION": {
      "HEADER": "Ifomu yokubhalisela",
      "SUBTITLE1": "Ukwenza ifomu lokubhalisa kuyithuluzi elivumela ukuqoqwa kwedatha mayelana nabasebenzisi.",
      "SUBTITLE2": "Hlela izinkambu zokuqongelela ngokwezidingo zakho uqinisekise ukuhambisana ne-RGPD."
    }
  },
  "STATS": {
    "AGE": {
      "BETWEEN_15_AND_29": "15-29",
      "BETWEEN_30_AND_44": "30-44",
      "BETWEEN_45_AND_59": "45-59",
      "BETWEEN_60_AND_74": "60-74",
      "GT_75": ">75",
      "LT_15": "<15",
      "TITLE": "Ubudala"
    },
    "AI": {
      "ACTIONS": "Izifiso zabasebenzisi:",
      "ACTIONS_TOOLTIP": "Lesi sifinyezo sezifiso zabasebenzisi sakhiwe yi-AI. Inhloso yaso ukusiza ukuqonda iminikelo yoqobo eyenziwe ababambiqhaza. Sincike eminikelweni ehlanganiswe ngezansi.",
      "ADD_CLUSTER": "Engeza iqembu lesihloko",
      "ADD_SUB_CLUSTER": "Engeza iqembu elincane",
      "CLUSTER": {
        "SUMMARY": "Incazelo yeqembu le-thematic",
        "SUMMARY_PLACEHOLDER": "Incazelo yeqembu lesihloko",
        "TITLE": "Igama leqembu lomsebenzi wangempela",
        "TITLE_PLACEHOLDER": "Igama leqembu le-thematic lizosebenza yi-AI ukuhlanganisa iminikelo."
      },
      "DELETE": "Susa",
      "DESCRIPTION": "Incazelo:",
      "EDIT": "Shintsha",
      "EDIT_CLUSTER": "Shintsha itimu",
      "EDIT_SUB_CLUSTER": "Lungisa iqembu elincane",
      "EXPLAIN_AI": "Sisebenzisa ubuhlakani bokwenziwa ukuhlola ngokucophelela izabelo zale ngxoxo. Inhloso yethu ukuziqoqa ngezigaba ezihlukene ngokwendlela ezifana ngayo, ukuze sikunikeze ukuqonda okungcono kwezimo, izifiso eziyinhloko, nezabelo ezivelayo. Ngale ndlela, uzokwazi kangcono ukubamba izabelo ezivelelayo nezimvo ezivelele ngaphakathi kwengxoxo.",
      "GENERATE": "Qala ukuhlaziya",
      "IDEAS": "Iminikelo yokuqala:",
      "IN_FAVOR": "Ngoba",
      "MOVE_IDEA": "Hambisa",
      "MOVE_IDEA_TITLE": "Shintsha iqembu lomxhasi noma iqembu elincane",
      "OPPOSED": "Ngokumelene",
      "SUB_CLUSTER": {
        "SUMMARY": "Incazelo yesigatshana esincane",
        "SUMMARY_PLACEHOLDER": "Incazelo yesigaba esingaphansi",
        "TITLE": "Igama leqembu elincane",
        "TITLE_PLACEHOLDER": "Igama leqembu elincane lezihloko lizosebenziswa yi-AI ukuhlanganisa iminikelo."
      },
      "TOAST": "Uxilongo lwe-AI luqhubeka. Lokhu kungathatha imizuzu embalwa."
    },
    "CITIES": {
      "TITLE": "Indawo yokuhlala"
    },
    "CLUSTERS": "Amagugu Ezihloko",
    "CLUSTERS_TOOLTIP": "Izifiso ezahlukene zabasebenzisi zihlanganiswa yi-AI ngaphakathi kwesihloko esisodwa noma eziningi.",
    "CLUSTER_OTHER": "Okunye",
    "COUNTER_WITH_TREND": {
      "TOOLTIP": "Kusukela ezinsukwini eziyi-7 ezedlule"
    },
    "COUNT_PROPOSALS": "{count} {count, plural, =0 {iminikelo} one {iminikelo} other {iminikelo}}",
    "DAY": "Usuku",
    "DELIVERABILITY": "Ukutholakala kwe-imeyili",
    "IDEAS_STATUSES": {
      "TITLE": "Isimo seNikelani"
    },
    "KPIS": {
      "TOTAL_COMMENTS": "{count, plural, 0 {Amazwana} one {Umbono} other {Amazwana}}",
      "TOTAL_FORM_RESPONSES": "{count, plural, 0 {Impendulo} one {Impendulo} other {Izimpendulo}}",
      "TOTAL_PARTICIPANTS": "{count, plural, 0 {Ababambiqhaza} one {Umhambeli} other {Ababambiqhaza}}",
      "TOTAL_VOTES_AGAINST": "{count, plural, 0 {Amavoti okubheka phansi} one {Ivoti lokubheka phansi} other {Amavoti okubheka phansi}}",
      "TOTAL_VOTES_FOR": "{count, plural, 0 {Amavoti ayi} one {Ivoti elilodwa} other {Amavoti ayi}}"
    },
    "MONTH": "Inyanga",
    "NO_DATA": "Alikho ulwazi olutholakalayo okwamanje.",
    "PARTICIPANTS": {
      "TITLE": "Inani labahlanganyeli",
      "TOTAL_PARTICIPANTS": "Abahlanganyeli",
      "TOTAL_TARGETED_USERS": "Abasebenzisi ababhalisiwe"
    },
    "PARTICIPANTS_PROGRESSION": "Ukukhula kwabathathi-nxaxheba",
    "PARTICIPANTS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Izinyathelo ezenziwe ngabahlanganyeli",
      "TOTAL_COMMENTS": "Amazwana",
      "TOTAL_IDEAS": "Yenza umnikelo",
      "TOTAL_NO_ACTIONS": "Azikho izenzo",
      "TOTAL_STUDY_ANSWERS": "Impendulo yocwaningo",
      "TOTAL_VOTES": "Vota"
    },
    "PARTICIPATION_PROGRESSION": "Ukuguquka kokubamba iqhaza",
    "PERFORMANCE": "Ukusebenza",
    "PROF_CATEGORIES": {
      "TITLE": "Isigaba sezinga lomsebenzi wezokuphila"
    },
    "REFERRERS": "Imithombo yezokuhamba",
    "SECTIONS": {
      "ACTIVITY": "Umsebenzi",
      "ENGAGEMENT": "Ukuzibophezela",
      "PARTICIPANTS_PROFILE": "Iphrofayela yababambiqhaza"
    },
    "SEX": {
      "TITLE": "Ubulili",
      "TOTAL_": "Akukhonjisiwe",
      "TOTAL_FEMALE": "Owesifazane",
      "TOTAL_MALE": "Indoda",
      "TOTAL_UNSPECIFIED": "Akucacisiwe"
    },
    "SUBSCRIPTIONS": {
      "TITLE": "Izinhloso Zokubhalisela",
      "TOTAL_TARGETED_USERS": "Inhloso",
      "TOTAL_USERS": "Abasebenzisi ababhalisiwe"
    },
    "SUBSCRIPTION_PROGRESSION": {
      "TITLE": "Ukushintsha kokubhaliswa"
    },
    "TAB_AI": "Ukuhlaziya kwe-AI (bêta)",
    "TAB_ATTENDEES": "Abahlanganyeli",
    "TAB_CONTENTS": "Okuqukethwe",
    "TAB_DETAILS": "Imininingwane",
    "TAB_EMAILS": "I-imeyili nomlobi",
    "TAB_LIST": "Uhlu",
    "TAB_PARTICIPATION": "Ukubamba iqhaza",
    "TAB_PRIVATE_NOTES": "Imibhalo yangaphakathi",
    "TAB_PROPOSALS": "Iminikelo",
    "TAB_RESPONSES": "Izimpendulo",
    "TAB_RESULTS": "Imiphumela",
    "TAB_SETTINGS": "Izilungiselelo",
    "TAB_STATS": "Izibalo",
    "TAB_VOTES": "Amavoti",
    "TARGETED_POPULATION": "Izibalo zabantu (umthombo osemthethweni)",
    "TOP_CONSULTATIONS": {
      "COL_TITLE": "Isihloko",
      "COL_TOTAL": "Ababambiqhaza",
      "SUBTITLE": "Inani lezinkokhelo, ukuphawula, amavoti noma izimpendulo kuhlolwe",
      "TITLE": "Izivumelwano zabantu"
    },
    "TOP_VIEWED_POSTS": {
      "COL_TITLE": "Isihloko",
      "COL_TOTAL": "Izivakashi",
      "COL_TYPE": "Uhlobo",
      "TITLE": "Okuqukethwe okuvakashelwa kakhulu"
    },
    "TOTAL_ANSWERS": "{answersCount} ku-{totalCount} {totalCount, plural, =0 {umphenduli} one {umphenduli} other {abaphenduli}}",
    "TOTAL_BOUNCED": "Phinde ugxumele",
    "TOTAL_CLICKED": "Kuchofozwa",
    "TOTAL_COMMENTS": "Amazwana",
    "TOTAL_COMMUNICATIONS": "Izindaba",
    "TOTAL_CONSULTATIONS": "Ukubonisana",
    "TOTAL_DELIVERED": "Délivré",
    "TOTAL_IDEAS": "Iminikelo",
    "TOTAL_OFFLINE_VOTES": "Amavoti abangaxhunyiwe ku-inthanethi",
    "TOTAL_ONLINE_VOTES": "amavoti aku-inthanethi",
    "TOTAL_OPENED": "Vulekile",
    "TOTAL_PARTICIPANTS": "Abahlanganyeli",
    "TOTAL_REJECTED": "Rehlisiwe",
    "TOTAL_RESPONDENTS": "Abaphendulile",
    "TOTAL_SENT": "Kuthunyelwe",
    "TOTAL_STUDY_ANSWERS": "Izimpendulo zocwaningo",
    "TOTAL_USERS": "Abasebenzisi ababhalisiwe",
    "TOTAL_VOTERS": "Abavoti",
    "TOTAL_VOTES": "Amavoti",
    "UNIQUE_VISITS": "Izivakashi ezihlukile",
    "USERS_WHO_ANSWERED": "{count} {count, plural, =0 {abaphendululi} one {umphendululi} other {abaphendululi}}",
    "USERS_WHO_PERFORMED_AN_ACTION": {
      "TITLE": "Izenzo ezenziwe ngabasebenzisi",
      "TOTAL_COMMENTS": "Amazwana",
      "TOTAL_IDEAS": "Ngabe wenze umnikelo",
      "TOTAL_NO_ACTIONS": "Ayikho isenzo",
      "TOTAL_STUDY_ANSWERS": "Izimpendulo zocwaningo",
      "TOTAL_VOTES": "Vota"
    },
    "WEEK": "Iviki",
    "WORD_CLOUD": "Igama eliyisihluthulelo lezwi"
  },
  "TEXT_FIELD": {
    "LENGTH": "{length}/{maxLength}",
    "LENGTH_ERROR": "{length}/{maxLength} - Usudlule umkhawulo wezinhlamvu.",
    "LENGTH_ERROR_TEXT": "Usudlulile umkhawulo wezinhlamvu."
  },
  "TOGGLE_POSTS_VIEW": {
    "BUTTON_CAROUSEL": "Isiqephu sokudlala",
    "BUTTON_GROUP": "Shintsha imodi yokubonisa",
    "BUTTON_LIST": "Uhlu",
    "BUTTON_MAP": "Ikhadi"
  },
  "TOKENS": "{count, plural, =0 {Azikho izimpawu} one {{count} uphawu} other {{count} izimpawu}}",
  "TOPIC_FORM": {
    "ADD_TOPIC": "Engeza isihloko esithile",
    "DESTROY_WARNING_DIALOG": {
      "DESCRIPTION_1": "Okunye noma okuningi okuqukethwe kweplathifomu yakho okwamanje kuhlukaniswe ngaphansi kwalesi sihloko.",
      "DESCRIPTION_2": "Uma uyiguqula noma uyisusa, uzoshintsha ukuhlukaniswa kwalokhu okuqukethwe.",
      "TITLE": "Uqinisekile?"
    }
  },
  "TRANSLATION": {
    "REVERSE_TRANSLATE": "Buka umbhalo wokuqala",
    "SUCCESS": "Ukuhumusha kwenziwe ngempumelelo.",
    "TRANSLATE": "Ukuhumusha",
    "TRANSLATING": "Ukuhumusha kuqhubeka…"
  },
  "UI_SECTION": {
    "FORM": {
      "ABOUT": {
        "SECTION_DESCRIPTION": "Amabhulokhi avumela ukwenza ngokwezifiso ikhasi lakho ngokugqamisa ulwazi olufomethwe umbhalo, isithombe nevidiyo.",
        "SECTION_HEADER": "Amabhulokhi"
      },
      "HOME": {
        "SECTION_DESCRIPTION": "Amabhulokhi avumela ukwenza ngendlela oyifisayo ikhasi lakho ngokugqamisa ulwazi oluhlelwe ngendlela yombhalo, isithombe, ividiyo kanye nokuqukethwe okugqamile.",
        "SECTION_HEADER": "Amabhulokhi"
      },
      "ITEMS": {
        "ANOMALY_FORM": {
          "DESCRIPTION": "Ukubika inkinga ngasese",
          "TITLE": "Ishodiwe elimazombe."
        },
        "CUSTOM_BLOCK": {
          "DESCRIPTION": "Umbhalo, isithombe nevidiyo",
          "TITLE": "Ngokwezifiso"
        },
        "DEMAND_FORM": {
          "DESCRIPTION": "Xhumana ngasese ngeqonga",
          "TITLE": "Imilayezo"
        },
        "FEATURED_CONSULTATIONS": {
          "DESCRIPTION": "Ukubonisana okubalulekile, okuqhubekayo nokuzayo",
          "TITLE": "Ukwelulekwa"
        },
        "FEATURED_NEWS": {
          "DESCRIPTION": "Isihloko nesenzakalo",
          "TITLE": "Izindaba zakamuva"
        },
        "FOLDERS": {
          "DESCRIPTION": "Ifayela nefolda engaphansi",
          "TITLE": "Uhlaka lwedokhumenti"
        },
        "KPIS": {
          "DESCRIPTION": "Inani lababhalisile, iminikelo nezivakashi",
          "TITLE": "Ezinye izinombolo"
        },
        "LATEST_IDEAS": {
          "DESCRIPTION": "Ukubamba iqhaza kwabasebenzisi",
          "TITLE": "Umnikelo"
        },
        "SPACE_INFO": {
          "TITLE": "Uhlaka olungaphezulu"
        }
      },
      "LAYER_ADD_MEDIA": "Engeza imidiya",
      "LAYER_ADD_PICTURE": "Isithombe",
      "LAYER_ADD_VIDEO": "Ividiyo",
      "LAYER_ALIGNMENT": {
        "CENTER": {
          "DESCRIPTION": "Imibhalo igxilile maqondana nabezindaba.",
          "LABEL": "Ngaphakathi"
        },
        "LEFT": {
          "DESCRIPTION": "Imibhalo isekhasi kwesobunxele semidiya.",
          "LABEL": "Ngakwesobunxele"
        },
        "RIGHT": {
          "DESCRIPTION": "Imibhalo isekhona kwesokudla semidiya.",
          "LABEL": "Ngakwesokudla"
        },
        "TITLE": "Ukubonisa"
      },
      "LAYER_COMMUNICATION_TYPE": {
        "ALL": "Zonke izindaba zakamuva",
        "ARTICLE": "I-athikhili",
        "EVENT": "Umcimbi",
        "LABEL": "Uhlobo",
        "PINNED": "Ezintsha"
      },
      "LAYER_CONSULTATION_TYPE": {
        "ALL": "Zonke izeluleko",
        "ENDED": "Izethulo ziphelile",
        "LABEL": "Uhlobo",
        "ONGOING": "Izithangami Zokuqhafaza Ziqhubeka",
        "PINNED": "Ezisematheni"
      },
      "LAYER_COUNTERS": {
        "CONSULTATIONS_COUNT": "Izinkulumo eziqaliswe",
        "CONTRIBUTIONS_COUNT": "Iminikelo ebonakalayo",
        "PARTICIPATIONS_COUNT": "Ukubamba iqhaza (iminikelo, izimpendulo zocwaningo, amavoti namazwana afakiwe)",
        "TITLE": "Bonisa isibalo se:",
        "USERS_AND_PARTICIPATIONS_COUNT": "Ukubhaliswa nokubamba iqhaza",
        "USERS_COUNT": "Ababhalisile"
      },
      "LAYER_CTA_LABEL": "Ibhokisi lelebuli",
      "LAYER_CTA_LABEL_PLACEHOLDER": "Lokho ofuna ukukubonisa enkombeni yebhathini",
      "LAYER_CTA_URL": "Ikheli le-Url yebhathini",
      "LAYER_CTA_URL_PLACEHOLDER": "Isixhumanisi somugqa noma umqulu",
      "LAYER_DESCRIPTION_LABEL": "Incazelo",
      "LAYER_DESCRIPTION_PLACEHOLDER": "Faka lapha okuqukethwe kombhalo webhulokhi. Yiba mfushane futhi uqonde ngqo.",
      "LAYER_FILTERING_TYPE": {
        "ALL": "Wonke amafayela",
        "CHILDREN": "Okuqukethwe kwefayela",
        "CUSTOM": "Ngokwezifiso",
        "SELECT_FOLDER": "Khetha ifolda",
        "SELECT_FOLDERS": "Khetha amafolda",
        "TYPE_LABEL": "Uhlobo lokuhlunga"
      },
      "LAYER_PICTURE_LABEL": "Isithombe",
      "LAYER_TITLE_LABEL": "Isihloko",
      "LAYER_TITLE_PLACEHOLDER": "Setha isihloko sebhulokhi",
      "SELECTION_DIALOG": {
        "TITLE": "Dala ibhulokhi"
      }
    }
  },
  "USERS": {
    "ACTIONS_MENU": {
      "CONTACT_USER": "Xhumana nomsebenzisi",
      "INVITE": "Mema",
      "UNREGISTER": "Khansela ukubhalisela",
      "UPDATE_ROLE": "Beka indima"
    },
    "EXPORT": "Ukuthekelisa kwedatha yomsebenzisi",
    "EXPORT_SUCCESS_TOAST": "Ukuthekelisa kuyaqhubeka. Uzothola i-imeyili uma sekulungile.",
    "INVITATIONS": {
      "CREATE_FORM": {
        "EMAILS_LABEL": "Uhlu lwama-imeyili ahlukaniswe ngamakhefu.",
        "EMAILS_PLACEHOLDER": "Isibonelo: umsebenzisi1@inhlangano.com, umsebenzisi2@inhlangano.org",
        "MESSAGE_LABEL": "Umlayezo wesimemo",
        "MESSAGE_PLACEHOLDER": "Faka umlayezo wesimemo omfishane futhi ugqugquzelayo, ozokwenza izimenywa zithande ukujoyina isikhala sakho futhi zibambe iqhaza.",
        "SUCCESS_TOAST": "Abasebenzisi bamemwe ngempumelelo.",
        "TITLE": "Memema abasebenzisi",
        "WARNING": "Qinisekisa ukuthi uthole imvume kubasebenzisi ngaphambi kokusebenzisa i-imeyili yabo ukubamenywa."
      },
      "DELETE_FORM": {
        "CONTENT": "Uzokwenza isenzo sokukhansela isimemo esithunyelwe ku-<b>{email}</b>. Uqinisekile ukuthi ufuna ukuqhubeka?",
        "DELETE": "Susa",
        "TITLE": "Susa isimemo"
      }
    },
    "UNREGISTER": {
      "DESCRIPTION_1": "Uzomisa ukubhaliswa komsebenzisi “<strong>{userName}</strong>” esikhaleni sakho sokubamba iqhaza.",
      "DESCRIPTION_2": "Uma isikhala siyimfihlo, umsebenzisi othintekayo ngeke akwazi ukufinyelela kuleso sikhala. Kuzodingeka ukuthi ummemele futhi ukuze uhlehlise lesi senzo.",
      "DESCRIPTION_3": "Uma isikhala singesidlangalaleni, umsebenzisi ophathekayo ngeke esakwazi ukubamba iqhaza. Uyodinga ukubhalisela kabusha ukuze akhansele lo msebenzi.",
      "DESCRIPTION_4": "Uqinisekile ukuthi ufuna ukuqhubeka nalesi senzo?",
      "TITLE": "Khansela umsebenzisi"
    }
  },
  "USER_AVATAR": "Isithombe somsebenzisi",
  "USER_VOTES_INFO": {
    "MAX_VOTES_ERROR": "Usufike inani eliphezulu lamavoti.",
    "MAX_VOTES_WARNING": "{count, plural, =0 {Awukwazi ukuxhasa izethulo eziningi} one {Ungaxhasa <strong># umnikelo</strong> owengeziwe.} other {Ungaxhasa <strong># iminikelo</strong> eyengeziwe.}}",
    "MIN_VOTES_WARNING": "{count, plural, =0 {Usenale ngokwanele izabelo} one {Kusele <strong># ukwesekwa</strong> ukuze kuvunyelwe ukubamba iqhaza kwakho.} other {Kusele <strong># ukwesekwa</strong> ukuze kuvunyelwe ukubamba iqhaza kwakho.}}",
    "VALID_PARTICIPATION": "Ukubamba kwakho iqhaza sekugunyaziwe."
  },
  "VIEW_ALL": "Buka konke",
  "VIRUS_SCAN": {
    "CLEAN": "Ukuhlaziywa kwe-antivirus kulungile",
    "INFECTED": "Ifayela eligulazwe",
    "INFECTED_ATTACHMENTS_ERROR": "Idokhumenti ibonakala sengathi ithelelekile. Sicela uyisuse ngaphambi kokulondoloza.",
    "NO_SCAN": "Ukuhlaziywa kwe-antivirus kuyaqhubeka"
  },
  "VOTERS": {
    "DUPLICATES": {
      "CARD": {
        "BIRTHDATE": "Usuku lokuzalwa: {birthdate}",
        "DELETE_VOTE": "Susa ivoti",
        "EMPTY": "Akukho okukhishiwe",
        "IMPORTED_AT": "Kungeniswe ngo-{date}",
        "KEEP_BOTH": "Gcina zombili",
        "PARTICIPATED_AT": "Ukubamba iqhaza ngo-{date}"
      },
      "DESCRIPTION": "Ukuhlaziywa kwama-doublons kubheka igama nesibongo sabasebenzisi. Ukuze ubhekane ne-doublon, khetha ivoti ofuna ukuyisusa phakathi kwezinhlangothi ezimbili.",
      "FOUND_DUPLICATES": "Unenamashe <b>{count, plural, one {{count} umuntu ovotayo ophindaphindiwe} other {{count} abantu abavotayo abaphindaphindiwe}}</b>. Kubuyekeziwe kokugcina <b>{timeAgo}</b>",
      "LOADING": "Ukuqinisekiswa kuyaqhubeka…",
      "NO_DUPLICATES": "Akukho okuphindaphindiwe okutholakele. Kubuyekeziwe kwakamuva <b>{timeAgo}</b>",
      "PLACEHOLDER": "Nazi lapha abavoti abakhonjwa njengokuphindaphinda.",
      "REFRESH": "Buyekeza",
      "START_CHECK": "Qalisa ukuqinisekisa",
      "TITLE": "Lawula ama-doublons"
    }
  },
  "WYSIWYG": {
    "LINK_PROMPT": {
      "ENTER_URL": "Faka i-URL"
    },
    "PLACEHOLDER": "Qala ngokuthayipha..."
  }
}